import { a as e, c as t, d as n, f as r, g as i, h as a, i as o, l as s, m as c, o as l, p as u, r as d, s as f, u as p } from "./defaultCommentEditorSchema-BWkUaI17.js";
import { a as m, c as h, i as g, o as _, r as v, s as y, t as b } from "./FloatingThreadController-BClaFoNJ.js";
import { r as ee, t as te } from "./FloatingComposerController-D-j-wzDn.js";
import ne, { Suspense as re, createContext as ie, forwardRef as ae, lazy as x, useCallback as S, useContext as oe, useEffect as C, useImperativeHandle as se, useMemo as w, useReducer as T, useRef as E, useState as D, useSyncExternalStore as ce } from "react";
import { CommentsExtension as O } from "@blocknote/core/comments";
import { DEFAULT_LINK_PROTOCOL as le, FilePanelExtension as k, FormattingToolbarExtension as A, LinkToolbarExtension as j, ShowSelectionExtension as ue, SideMenuExtension as M, SuggestionMenu as N, TableHandlesExtension as P, VALID_LINK_PROTOCOLS as de, filterSuggestionItems as fe, getDefaultEmojiPickerItems as pe, getDefaultSlashMenuItems as me } from "@blocknote/core/extensions";
import { autoPlacement as he, autoUpdate as ge, flip as _e, offset as F, safePolygon as ve, shift as ye, size as I, useFloating as be, useTransitionStyles as xe } from "@floating-ui/react";
import { EMPTY_CELL_HEIGHT as Se, EMPTY_CELL_WIDTH as Ce, UnreachableCaseError as we, addInlineContentAttributes as Te, addInlineContentKeyboardShortcuts as Ee, addStyleAttributes as De, audioParse as Oe, blockHasType as L, camelToDataKebab as ke, createAudioBlockConfig as Ae, createFileBlockConfig as je, createImageBlockConfig as Me, createInternalInlineContentSpec as Ne, createInternalStyleSpec as Pe, createVideoBlockConfig as Fe, defaultProps as R, defaultToggledState as z, editorHasBlockWithType as B, fileParse as Ie, filenameFromURL as Le, formatKeyboardShortcut as V, getBlockFromPos as Re, getColspan as ze, getInlineContentParseRules as Be, getNodeById as Ve, getPageBreakSlashMenuItems as He, getRowspan as Ue, getStyleParseRules as We, imageParse as Ge, inlineContentToNodes as Ke, isTableCell as H, isTableCellSelection as qe, mapTableCell as U, mergeCSSClasses as W, nodeToCustomInlineContent as Je, propsToAttributes as Ye, stylePropsToAttributes as Xe, videoParse as Ze } from "@blocknote/core";
import { Fragment as G, jsx as K, jsxs as q } from "react/jsx-runtime";
import { Node as Qe } from "@tiptap/core";
import { RiAddFill as $e, RiAlignCenter as et, RiAlignJustify as tt, RiAlignLeft as nt, RiAlignRight as rt, RiBold as it, RiChat3Line as at, RiCodeBlock as ot, RiCodeFill as st, RiDeleteBin7Line as ct, RiDownload2Fill as lt, RiEmotionFill as ut, RiExternalLinkFill as dt, RiFile2Line as ft, RiFilmLine as pt, RiFontFamily as mt, RiH1 as ht, RiH2 as gt, RiH3 as _t, RiH4 as vt, RiH5 as yt, RiH6 as bt, RiImage2Fill as xt, RiImageAddFill as St, RiImageEditFill as Ct, RiIndentDecrease as wt, RiIndentIncrease as Tt, RiInputField as Et, RiItalic as Dt, RiLink as Ot, RiLinkUnlink as kt, RiListCheck3 as At, RiListOrdered as jt, RiListUnordered as Mt, RiMergeCellsHorizontal as Nt, RiMergeCellsVertical as Pt, RiPlayList2Fill as Ft, RiQuoteText as It, RiStrikethrough as Lt, RiSubtractLine as Rt, RiTable2 as zt, RiText as Bt, RiUnderline as Vt, RiVideoFill as Ht, RiVolumeUpFill as Ut } from "react-icons/ri";
import { AiOutlinePlus as Wt } from "react-icons/ai";
import { MdArrowDropDown as Gt, MdDragIndicator as Kt } from "react-icons/md";
import { createPortal as qt, flushSync as Jt } from "react-dom";
import { Mark as Yt, NodeViewWrapper as Xt, ReactMarkViewContext as Zt, ReactMarkViewRenderer as Qt, ReactNodeViewRenderer as $t, useReactNodeView as en } from "@tiptap/react";
import { createRoot as tn } from "react-dom/client";
import { TbPageBreak as nn } from "react-icons/tb";
//#region src/components/Popovers/BlockPopover.tsx
var rn = (e) => {
	let { blockId: t, children: n, portalElement: r, ...i } = e, a = c();
	return /* @__PURE__ */ K(p, {
		reference: w(() => a.transact((e) => {
			if (!t) return;
			let n = Ve(t, e.doc);
			if (!n) return;
			let { node: r } = a.prosemirrorView.domAtPos(n.posBeforeNode + 1);
			if (r instanceof Element) return { element: r };
		}), [a, t]),
		portalElement: r,
		...i,
		children: t !== void 0 && n
	});
}, an = (e) => {
	let t = s(), n = f(), r = c(), i = r.getBlock(e.blockId), [a, o] = D(""), l = S((e) => {
		o(e.currentTarget.value);
	}, []), u = S((e) => {
		e.key === "Enter" && !e.nativeEvent.isComposing && (e.preventDefault(), r.updateBlock(i.id, { props: {
			name: Le(a),
			url: a
		} }));
	}, [
		r,
		i.id,
		a
	]), d = S(() => {
		r.updateBlock(i.id, { props: {
			name: Le(a),
			url: a
		} });
	}, [
		r,
		i.id,
		a
	]);
	return /* @__PURE__ */ q(t.FilePanel.TabPanel, {
		className: "bn-tab-panel",
		children: [/* @__PURE__ */ K(t.FilePanel.TextInput, {
			className: "bn-text-input",
			placeholder: n.file_panel.embed.url_placeholder,
			value: a,
			onChange: l,
			onKeyDown: u,
			"data-test": "embed-input"
		}), /* @__PURE__ */ K(t.FilePanel.Button, {
			className: "bn-button",
			onClick: d,
			"data-test": "embed-input-button",
			children: n.file_panel.embed.embed_button[i.type] || n.file_panel.embed.embed_button.file
		})]
	});
}, on = (e) => {
	let t = s(), n = f(), { setLoading: r } = e, i = c(), a = i.getBlock(e.blockId), [o, l] = D(!1);
	C(() => {
		o && setTimeout(() => {
			l(!1);
		}, 3e3);
	}, [o]);
	let u = S((t) => {
		if (t === null) return;
		async function n(t) {
			if (r(!0), i.uploadFile !== void 0) try {
				let n = await i.uploadFile(t, e.blockId);
				typeof n == "string" && (n = { props: {
					name: t.name,
					url: n
				} }), i.updateBlock(e.blockId, n);
			} catch {
				l(!0);
			} finally {
				r(!1);
			}
		}
		n(t);
	}, [
		e.blockId,
		i,
		r
	]), d = i.schema.blockSpecs[a.type], p = d.implementation.meta?.fileBlockAccept?.length ? d.implementation.meta.fileBlockAccept.join(",") : "*/*";
	return /* @__PURE__ */ q(t.FilePanel.TabPanel, {
		className: "bn-tab-panel",
		children: [/* @__PURE__ */ K(t.FilePanel.FileInput, {
			className: "bn-file-input",
			"data-test": "upload-input",
			accept: p,
			placeholder: n.file_panel.upload.file_placeholder[a.type] || n.file_panel.upload.file_placeholder.file,
			value: null,
			onChange: u
		}), o && /* @__PURE__ */ K("div", {
			className: "bn-error-text",
			children: n.file_panel.upload.upload_error
		})]
	});
}, sn = (e) => {
	let t = s(), n = f(), r = c(), [i, a] = D(!1), o = e.tabs ?? [...r.uploadFile === void 0 ? [] : [{
		name: n.file_panel.upload.title,
		tabPanel: /* @__PURE__ */ K(on, {
			blockId: e.blockId,
			setLoading: a
		})
	}], {
		name: n.file_panel.embed.title,
		tabPanel: /* @__PURE__ */ K(an, { blockId: e.blockId })
	}], [l, u] = D(e.defaultOpenTab || o[0].name);
	return /* @__PURE__ */ K(t.FilePanel.Root, {
		className: "bn-panel",
		defaultOpenTab: l,
		openTab: l,
		setOpenTab: u,
		tabs: o,
		loading: i
	});
}, cn = (e) => {
	let t = c(), n = r(k), i = u(k), a = w(() => ({
		...e.floatingUIOptions,
		useFloatingOptions: {
			open: !!i,
			onOpenChange: (e, r, i) => {
				e || n.closeMenu(), i === "escape-key" && t.focus();
			},
			middleware: [F(10), _e()],
			...e.floatingUIOptions?.useFloatingOptions
		},
		focusManagerProps: {
			disabled: !0,
			...e.floatingUIOptions?.focusManagerProps
		},
		elementProps: {
			style: { zIndex: 90 },
			...e.floatingUIOptions?.elementProps
		}
	}), [
		i,
		t,
		n,
		e.floatingUIOptions
	]), o = e.filePanel || sn;
	return /* @__PURE__ */ K(rn, {
		blockId: i,
		portalElement: e.portalElement,
		...a,
		children: i && /* @__PURE__ */ K(o, { blockId: i })
	});
}, ln = {
	bold: it,
	italic: Dt,
	underline: Vt,
	strike: Lt,
	code: st
};
function un(e, t) {
	return e in t.schema.styleSchema && t.schema.styleSchema[e].type === e && t.schema.styleSchema[e].propSchema === "boolean";
}
var J = (e) => {
	let t = f(), n = s(), r = c(), i = l({
		editor: r,
		selector: ({ editor: t }) => {
			if (!(!t.isEditable || !un(e.basicTextStyle, t) || !(t.getSelection()?.blocks || [t.getTextCursorPosition().block]).find((e) => e.content !== void 0))) return e.basicTextStyle in t.getActiveStyles() ? { active: !0 } : { active: !1 };
		}
	}), a = S((e) => {
		r.focus(), r.toggleStyles({ [e]: !0 });
	}, [r, e]);
	if (i === void 0) return null;
	let o = ln[e.basicTextStyle];
	return /* @__PURE__ */ K(n.FormattingToolbar.Button, {
		className: "bn-button",
		"data-test": e.basicTextStyle,
		onClick: () => a(e.basicTextStyle),
		isSelected: i.active,
		label: t.formatting_toolbar[e.basicTextStyle].tooltip,
		mainTooltip: t.formatting_toolbar[e.basicTextStyle].tooltip,
		secondaryTooltip: V(t.formatting_toolbar[e.basicTextStyle].secondary_tooltip, t.generic.ctrl_shortcut),
		icon: /* @__PURE__ */ K(o, {})
	});
}, dn = (e) => {
	let t = e.textColor || "default", n = e.backgroundColor || "default", r = e.size || 16;
	return /* @__PURE__ */ K("div", {
		className: "bn-color-icon",
		"data-background-color": n,
		"data-text-color": t,
		style: w(() => ({
			pointerEvents: "none",
			fontSize: (r * .75).toString() + "px",
			height: r.toString() + "px",
			lineHeight: r.toString() + "px",
			textAlign: "center",
			width: r.toString() + "px"
		}), [r]),
		children: "A"
	});
}, fn = [
	"default",
	"gray",
	"brown",
	"red",
	"orange",
	"yellow",
	"green",
	"blue",
	"purple",
	"pink"
], pn = (e) => {
	let t = s(), n = f();
	return /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(() => e.text ? /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(t.Generic.Menu.Label, { children: n.color_picker.text_title }), fn.map((r) => /* @__PURE__ */ K(t.Generic.Menu.Item, {
		onClick: () => {
			e.onClick && e.onClick(), e.text.setColor(r);
		},
		"data-test": "text-color-" + r,
		icon: /* @__PURE__ */ K(dn, {
			textColor: r,
			size: e.iconSize
		}),
		checked: e.text.color === r,
		children: n.color_picker.colors[r]
	}, "text-color-" + r))] }) : null, {}), /* @__PURE__ */ K(() => e.background ? /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(t.Generic.Menu.Label, { children: n.color_picker.background_title }), fn.map((r) => /* @__PURE__ */ K(t.Generic.Menu.Item, {
		onClick: () => {
			e.onClick && e.onClick(), e.background.setColor(r);
		},
		"data-test": "background-color-" + r,
		icon: /* @__PURE__ */ K(dn, {
			backgroundColor: r,
			size: e.iconSize
		}),
		checked: e.background.color === r,
		children: n.color_picker.colors[r]
	}, "background-color-" + r))] }) : null, {})] });
};
//#endregion
//#region src/components/FormattingToolbar/DefaultButtons/ColorStyleButton.tsx
function mn(e, t) {
	return `${e}Color` in t.schema.styleSchema && t.schema.styleSchema[`${e}Color`].type === `${e}Color` && t.schema.styleSchema[`${e}Color`].propSchema === "string";
}
var hn = () => {
	let e = s(), t = f(), n = c(), r = mn("text", n), i = mn("background", n), a = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!e.isEditable || !(e.getSelection()?.blocks || [e.getTextCursorPosition().block]).find((e) => e.content !== void 0)) return;
			let t = mn("text", e), n = mn("background", e);
			if (!(!t && !n)) return {
				textColor: t ? e.getActiveStyles().textColor || "default" : void 0,
				backgroundColor: n ? e.getActiveStyles().backgroundColor || "default" : void 0
			};
		}
	}), o = S((e) => {
		if (!r) throw Error("Tried to set text color, but style does not exist in editor schema.");
		e === "default" ? n.removeStyles({ textColor: e }) : n.addStyles({ textColor: e }), setTimeout(() => {
			n.focus();
		});
	}, [n, r]), u = S((e) => {
		if (!i) throw Error("Tried to set background color, but style does not exist in editor schema.");
		e === "default" ? n.removeStyles({ backgroundColor: e }) : n.addStyles({ backgroundColor: e }), setTimeout(() => {
			n.focus();
		});
	}, [i, n]);
	return a === void 0 ? null : /* @__PURE__ */ q(e.Generic.Menu.Root, { children: [/* @__PURE__ */ K(e.Generic.Menu.Trigger, { children: /* @__PURE__ */ K(e.FormattingToolbar.Button, {
		className: "bn-button",
		"data-test": "colors",
		label: t.formatting_toolbar.colors.tooltip,
		mainTooltip: t.formatting_toolbar.colors.tooltip,
		icon: /* @__PURE__ */ K(dn, {
			textColor: a.textColor,
			backgroundColor: a.backgroundColor,
			size: 20
		})
	}) }), /* @__PURE__ */ K(e.Generic.Menu.Dropdown, {
		className: "bn-menu-dropdown bn-color-picker-dropdown",
		children: /* @__PURE__ */ K(pn, {
			text: a.textColor ? {
				color: a.textColor,
				setColor: o
			} : void 0,
			background: a.backgroundColor ? {
				color: a.backgroundColor,
				setColor: u
			} : void 0
		})
	})] });
}, gn = (e) => {
	for (let t of de) if (e.startsWith(t)) return e;
	return `${le}://${e}`;
}, _n = (e) => {
	let t = s(), n = f(), { editLink: i } = r(j), { url: a, text: o, showTextField: c } = e, [l, u] = D(a), [d, p] = D(o);
	C(() => {
		u(a), p(o);
	}, [o, a]);
	let m = S((t) => {
		t.key === "Enter" && !t.nativeEvent.isComposing && (t.preventDefault(), i(gn(l), d, e.range.from), e.setToolbarOpen?.(!1), e.setToolbarPositionFrozen?.(!1));
	}, [
		i,
		l,
		d,
		e
	]), h = S((e) => u(e.currentTarget.value), []), g = S((e) => p(e.currentTarget.value), []), _ = S(() => {
		i(gn(l), d, e.range.from), e.setToolbarOpen?.(!1), e.setToolbarPositionFrozen?.(!1);
	}, [
		i,
		l,
		d,
		e
	]);
	return /* @__PURE__ */ q(t.Generic.Form.Root, { children: [/* @__PURE__ */ K(t.Generic.Form.TextInput, {
		className: "bn-text-input",
		name: "url",
		icon: /* @__PURE__ */ K(Ot, {}),
		autoFocus: !0,
		placeholder: n.link_toolbar.form.url_placeholder,
		value: l,
		onKeyDown: m,
		onChange: h,
		onSubmit: _
	}), c !== !1 && /* @__PURE__ */ K(t.Generic.Form.TextInput, {
		className: "bn-text-input",
		name: "title",
		icon: /* @__PURE__ */ K(Bt, {}),
		placeholder: n.link_toolbar.form.title_placeholder,
		value: d,
		onKeyDown: m,
		onChange: g,
		onSubmit: _
	})] });
};
//#endregion
//#region src/components/FormattingToolbar/DefaultButtons/CreateLinkButton.tsx
function vn(e) {
	return "link" in e.schema.inlineContentSchema && e.schema.inlineContentSchema.link === "link";
}
var yn = () => {
	let t = c(), n = e(), i = s(), a = f(), o = r(A), { showSelection: u } = r(ue), [d, p] = D(!1);
	C(() => (u(d, "createLinkButton"), () => u(!1, "createLinkButton")), [d, u]);
	let m = l({
		editor: t,
		selector: ({ editor: e }) => {
			if (!(!e.isEditable || !vn(e) || qe(e.prosemirrorState.selection) || !(e.getSelection()?.blocks || [e.getTextCursorPosition().block]).find((e) => e.content !== void 0))) return {
				url: e.getSelectedLinkUrl(),
				text: e.getSelectedText(),
				range: {
					from: e.prosemirrorState.selection.from,
					to: e.prosemirrorState.selection.to
				}
			};
		}
	});
	return C(() => {
		p(!1);
	}, [m]), C(() => {
		let e = (e) => {
			(e.ctrlKey || e.metaKey) && e.key === "k" && (p(!0), e.preventDefault());
		};
		return n?.addEventListener("keydown", e), () => {
			n?.removeEventListener("keydown", e);
		};
	}, [n]), m === void 0 ? null : /* @__PURE__ */ q(i.Generic.Popover.Root, {
		open: d,
		onOpenChange: p,
		children: [/* @__PURE__ */ K(i.Generic.Popover.Trigger, { children: /* @__PURE__ */ K(i.FormattingToolbar.Button, {
			className: "bn-button",
			"data-test": "createLink",
			label: a.formatting_toolbar.link.tooltip,
			mainTooltip: a.formatting_toolbar.link.tooltip,
			secondaryTooltip: V(a.formatting_toolbar.link.secondary_tooltip, a.generic.ctrl_shortcut),
			icon: /* @__PURE__ */ K(Ot, {}),
			onClick: () => p((e) => !e)
		}) }), /* @__PURE__ */ K(i.Generic.Popover.Content, {
			className: "bn-popover-content bn-form-popover",
			variant: "form-popover",
			children: /* @__PURE__ */ K(_n, {
				url: m.url || "",
				text: m.text,
				range: m.range,
				showTextField: !1,
				setToolbarOpen: (e) => o.store.setState(e)
			})
		})]
	});
}, bn = () => {
	let e = f(), t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!e.isEditable) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block];
			if (t.length !== 1) return;
			let n = t[0];
			if (L(n, e, n.type, {
				url: "string",
				caption: "string"
			})) return n;
		}
	}), [i, a] = D(!1), o = S((e) => {
		r !== void 0 && B(n, r.type, { caption: "string" }) && n.updateBlock(r.id, { props: { caption: e.currentTarget.value } });
	}, [r, n]), u = S((e) => {
		e.key === "Enter" && !e.nativeEvent.isComposing && (e.preventDefault(), a(!1));
	}, []);
	return r === void 0 ? null : /* @__PURE__ */ q(t.Generic.Popover.Root, {
		open: i,
		onOpenChange: a,
		children: [/* @__PURE__ */ K(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ K(t.FormattingToolbar.Button, {
			className: "bn-button",
			label: e.formatting_toolbar.file_caption.tooltip,
			mainTooltip: e.formatting_toolbar.file_caption.tooltip,
			icon: /* @__PURE__ */ K(Et, {}),
			onClick: () => a((e) => !e)
		}) }), /* @__PURE__ */ K(t.Generic.Popover.Content, {
			className: "bn-popover-content bn-form-popover",
			variant: "form-popover",
			children: /* @__PURE__ */ K(t.Generic.Form.Root, { children: /* @__PURE__ */ K(t.Generic.Form.TextInput, {
				name: "file-caption",
				icon: /* @__PURE__ */ K(Et, {}),
				value: r.props.caption,
				autoFocus: !0,
				placeholder: e.formatting_toolbar.file_caption.input_placeholder,
				onKeyDown: u,
				onChange: o
			}) })
		})]
	});
}, xn = () => {
	let e = f(), t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!e.isEditable) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block];
			if (t.length !== 1) return;
			let n = t[0];
			if (L(n, e, n.type, { url: "string" })) return n;
		}
	}), i = S(() => {
		r !== void 0 && (n.focus(), n.removeBlocks([r.id]));
	}, [r, n]);
	return r === void 0 ? null : /* @__PURE__ */ K(t.FormattingToolbar.Button, {
		className: "bn-button",
		label: e.formatting_toolbar.file_delete.tooltip[r.type] || e.formatting_toolbar.file_delete.tooltip.file,
		mainTooltip: e.formatting_toolbar.file_delete.tooltip[r.type] || e.formatting_toolbar.file_delete.tooltip.file,
		icon: /* @__PURE__ */ K(ct, {}),
		onClick: i
	});
}, Sn = () => {
	let e = f(), t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!e.isEditable) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block];
			if (t.length !== 1) return;
			let n = t[0];
			if (L(n, e, n.type, {
				url: "string",
				name: "string"
			})) return n;
		}
	}), [i, a] = D(!1), o = S((e) => {
		r !== void 0 && B(n, r.type, { name: "string" }) && n.updateBlock(r.id, { props: { name: e.currentTarget.value } });
	}, [r, n]), u = S((e) => {
		e.key === "Enter" && !e.nativeEvent.isComposing && (e.preventDefault(), a(!1));
	}, []);
	return r === void 0 ? null : /* @__PURE__ */ q(t.Generic.Popover.Root, {
		open: i,
		onOpenChange: a,
		children: [/* @__PURE__ */ K(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ K(t.FormattingToolbar.Button, {
			className: "bn-button",
			label: e.formatting_toolbar.file_rename.tooltip[r.type] || e.formatting_toolbar.file_rename.tooltip.file,
			mainTooltip: e.formatting_toolbar.file_rename.tooltip[r.type] || e.formatting_toolbar.file_rename.tooltip.file,
			icon: /* @__PURE__ */ K(mt, {}),
			onClick: () => a((e) => !e)
		}) }), /* @__PURE__ */ K(t.Generic.Popover.Content, {
			className: "bn-popover-content bn-form-popover",
			variant: "form-popover",
			children: /* @__PURE__ */ K(t.Generic.Form.Root, { children: /* @__PURE__ */ K(t.Generic.Form.TextInput, {
				name: "file-name",
				icon: /* @__PURE__ */ K(mt, {}),
				value: r.props.name,
				autoFocus: !0,
				placeholder: e.formatting_toolbar.file_rename.input_placeholder[r.type] || e.formatting_toolbar.file_rename.input_placeholder.file,
				onKeyDown: u,
				onChange: o
			}) })
		})]
	});
}, Cn = () => {
	let e = f(), t = s(), n = l({
		editor: c(),
		selector: ({ editor: e }) => {
			if (!e.isEditable) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block];
			if (t.length !== 1) return;
			let n = t[0];
			if (L(n, e, n.type, { url: "string" })) return n;
		}
	});
	return n === void 0 ? null : /* @__PURE__ */ q(t.Generic.Popover.Root, {
		position: "bottom",
		children: [/* @__PURE__ */ K(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ K(t.FormattingToolbar.Button, {
			className: "bn-button",
			mainTooltip: e.formatting_toolbar.file_replace.tooltip[n.type] || e.formatting_toolbar.file_replace.tooltip.file,
			label: e.formatting_toolbar.file_replace.tooltip[n.type] || e.formatting_toolbar.file_replace.tooltip.file,
			icon: /* @__PURE__ */ K(Ct, {})
		}) }), /* @__PURE__ */ K(t.Generic.Popover.Content, {
			className: "bn-popover-content bn-panel-popover",
			variant: "panel-popover",
			children: /* @__PURE__ */ K(sn, { blockId: n.id })
		})]
	});
}, wn = () => {
	let e = f(), t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!(!e.isEditable || !(e.getSelection()?.blocks || [e.getTextCursorPosition().block]).find((e) => e.content !== void 0))) return { canNestBlock: e.canNestBlock() };
		}
	}), i = S(() => {
		r !== void 0 && r.canNestBlock && (n.focus(), n.nestBlock());
	}, [n, r]);
	return r === void 0 ? null : /* @__PURE__ */ K(t.FormattingToolbar.Button, {
		className: "bn-button",
		"data-test": "nestBlock",
		onClick: i,
		isDisabled: !r.canNestBlock,
		label: e.formatting_toolbar.nest.tooltip,
		mainTooltip: e.formatting_toolbar.nest.tooltip,
		secondaryTooltip: V(e.formatting_toolbar.nest.secondary_tooltip, e.generic.ctrl_shortcut),
		icon: /* @__PURE__ */ K(Tt, {})
	});
}, Tn = () => {
	let e = f(), t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!(!e.isEditable || !(e.getSelection()?.blocks || [e.getTextCursorPosition().block]).find((e) => e.content !== void 0))) return { canUnnestBlock: e.canUnnestBlock() };
		}
	}), i = S(() => {
		r !== void 0 && r.canUnnestBlock && (n.focus(), n.unnestBlock());
	}, [n, r]);
	return r === void 0 ? null : /* @__PURE__ */ K(t.FormattingToolbar.Button, {
		className: "bn-button",
		"data-test": "unnestBlock",
		onClick: i,
		isDisabled: !r.canUnnestBlock,
		label: e.formatting_toolbar.unnest.tooltip,
		mainTooltip: e.formatting_toolbar.unnest.tooltip,
		secondaryTooltip: V(e.formatting_toolbar.unnest.secondary_tooltip, e.generic.ctrl_shortcut),
		icon: /* @__PURE__ */ K(wt, {})
	});
}, En = (e) => [
	{
		name: e.slash_menu.paragraph.title,
		type: "paragraph",
		icon: Bt
	},
	{
		name: e.slash_menu.heading.title,
		type: "heading",
		props: {
			level: 1,
			isToggleable: !1
		},
		icon: ht
	},
	{
		name: e.slash_menu.heading_2.title,
		type: "heading",
		props: {
			level: 2,
			isToggleable: !1
		},
		icon: gt
	},
	{
		name: e.slash_menu.heading_3.title,
		type: "heading",
		props: {
			level: 3,
			isToggleable: !1
		},
		icon: _t
	},
	{
		name: e.slash_menu.heading_4.title,
		type: "heading",
		props: {
			level: 4,
			isToggleable: !1
		},
		icon: vt
	},
	{
		name: e.slash_menu.heading_5.title,
		type: "heading",
		props: {
			level: 5,
			isToggleable: !1
		},
		icon: yt
	},
	{
		name: e.slash_menu.heading_6.title,
		type: "heading",
		props: {
			level: 6,
			isToggleable: !1
		},
		icon: bt
	},
	{
		name: e.slash_menu.toggle_heading.title,
		type: "heading",
		props: {
			level: 1,
			isToggleable: !0
		},
		icon: ht
	},
	{
		name: e.slash_menu.toggle_heading_2.title,
		type: "heading",
		props: {
			level: 2,
			isToggleable: !0
		},
		icon: gt
	},
	{
		name: e.slash_menu.toggle_heading_3.title,
		type: "heading",
		props: {
			level: 3,
			isToggleable: !0
		},
		icon: _t
	},
	{
		name: e.slash_menu.quote.title,
		type: "quote",
		icon: It
	},
	{
		name: e.slash_menu.toggle_list.title,
		type: "toggleListItem",
		icon: Ft
	},
	{
		name: e.slash_menu.bullet_list.title,
		type: "bulletListItem",
		icon: Mt
	},
	{
		name: e.slash_menu.numbered_list.title,
		type: "numberedListItem",
		icon: jt
	},
	{
		name: e.slash_menu.check_list.title,
		type: "checkListItem",
		icon: At
	}
], Dn = (e) => {
	let t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => e.getSelection()?.blocks || [e.getTextCursorPosition().block]
	}), i = r[0], a = w(() => (e.items || En(n.dictionary)).filter((e) => B(n, e.type, Object.fromEntries(Object.entries(e.props || {}).map(([e, t]) => [e, typeof t])))), [n, e.items]), o = w(() => a.map((e) => {
		let t = e.icon, a = e.type === i.type, o = Object.entries(e.props || {}).filter(([e, t]) => t !== i.props[e]).length === 0;
		return {
			text: e.name,
			icon: /* @__PURE__ */ K(t, { size: 16 }),
			onClick: () => {
				n.focus(), n.transact(() => {
					for (let t of r) n.updateBlock(t, {
						type: e.type,
						props: e.props
					});
				});
			},
			isSelected: a && o
		};
	}), [
		n,
		a,
		i.props,
		i.type,
		r
	]);
	return !w(() => o.find((e) => e.isSelected) !== void 0, [o]) || !n.isEditable ? null : /* @__PURE__ */ K(t.FormattingToolbar.Select, {
		className: "bn-select",
		items: o
	});
}, On = () => {
	let e = f(), t = s(), n = r("comments"), { store: i } = r(A), a = S(() => {
		n.startPendingComment(), i.setState(!1);
	}, [n, i]);
	return /* @__PURE__ */ K(t.FormattingToolbar.Button, {
		className: "bn-button",
		label: e.formatting_toolbar.comment.tooltip,
		mainTooltip: e.formatting_toolbar.comment.tooltip,
		icon: /* @__PURE__ */ K(at, {}),
		onClick: a
	});
}, kn = () => c().getExtension("comments") ? /* @__PURE__ */ K(On, {}) : null, An = () => {
	let e = f(), t = s(), n = c(), r = S(() => {
		n._tiptapEditor.chain().focus().addPendingComment().run();
	}, [n]);
	return !n._tiptapEditor.commands.addPendingComment || !n.isEditable ? null : /* @__PURE__ */ K(t.FormattingToolbar.Button, {
		className: "bn-button",
		label: e.formatting_toolbar.comment.tooltip,
		mainTooltip: e.formatting_toolbar.comment.tooltip,
		icon: /* @__PURE__ */ K(at, {}),
		onClick: r
	});
};
//#endregion
//#region src/util/sanitizeUrl.ts
function jn(e, t) {
	try {
		let n = new URL(e, t);
		if (n.protocol !== "javascript:") return n.href;
	} catch {}
	return "#";
}
//#endregion
//#region src/components/FormattingToolbar/DefaultButtons/FileDownloadButton.tsx
var Mn = () => {
	let e = f(), t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block];
			if (t.length !== 1) return;
			let n = t[0];
			if (L(n, e, n.type, { url: "string" })) return n;
		}
	}), i = S(() => {
		r !== void 0 && (n.focus(), n.resolveFileUrl ? n.resolveFileUrl(r.props.url).then((e) => window.open(jn(e, window.location.href))) : window.open(jn(r.props.url, window.location.href)));
	}, [r, n]);
	return r === void 0 ? null : /* @__PURE__ */ K(t.FormattingToolbar.Button, {
		className: "bn-button",
		label: e.formatting_toolbar.file_download.tooltip[r.type] || e.formatting_toolbar.file_download.tooltip.file,
		mainTooltip: e.formatting_toolbar.file_download.tooltip[r.type] || e.formatting_toolbar.file_download.tooltip.file,
		icon: /* @__PURE__ */ K(lt, {}),
		onClick: i
	});
}, Nn = () => {
	let e = f(), t = s(), n = c(), r = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!e.isEditable) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block];
			if (t.length !== 1) return;
			let n = t[0];
			if (L(n, e, n.type, {
				url: "string",
				showPreview: "boolean"
			})) return n;
		}
	}), i = S(() => {
		r !== void 0 && B(n, r.type, { showPreview: "boolean" }) && n.updateBlock(r.id, { props: { showPreview: !r.props.showPreview } });
	}, [r, n]);
	return r === void 0 ? null : /* @__PURE__ */ K(t.FormattingToolbar.Button, {
		className: "bn-button",
		label: "Toggle preview",
		mainTooltip: e.formatting_toolbar.file_preview_toggle.tooltip,
		icon: /* @__PURE__ */ K(St, {}),
		isSelected: r.props.showPreview,
		onClick: i
	});
}, Pn = () => {
	let e = f(), t = s(), n = c(), i = r(P), a = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!e.isEditable || !e.settings.tables.splitCells) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block];
			if (t.length !== 1) return;
			let n = t[0];
			if (n.type === "table") return { mergeDirection: i.getMergeDirection(n) };
		}
	}), o = S(() => {
		i?.mergeCells();
	}, [i]);
	return a === void 0 ? null : /* @__PURE__ */ K(t.FormattingToolbar.Button, {
		className: "bn-button",
		label: e.formatting_toolbar.table_cell_merge.tooltip,
		mainTooltip: e.formatting_toolbar.table_cell_merge.tooltip,
		icon: a.mergeDirection === "horizontal" ? /* @__PURE__ */ K(Nt, {}) : /* @__PURE__ */ K(Pt, {}),
		onClick: o
	});
}, Fn = () => c().getExtension(P) ? /* @__PURE__ */ K(Pn, {}) : null, In = {
	left: nt,
	center: et,
	right: rt,
	justify: tt
}, Ln = (e) => {
	let t = s(), n = f(), r = c(), i = l({
		editor: r,
		selector: ({ editor: e }) => {
			if (!e.isEditable) return;
			let t = e.getSelection()?.blocks || [e.getTextCursorPosition().block], n = t[0];
			if (L(n, e, n.type, { textAlignment: R.textAlignment })) return {
				textAlignment: n.props.textAlignment,
				blocks: t
			};
			if (t.length === 1 && L(n, e, "table")) return e.getExtension(P)?.getCellSelection() ? {
				textAlignment: U(n.content.rows[0].cells[0]).props.textAlignment,
				blocks: [n]
			} : void 0;
		}
	}), a = S((e) => {
		if (i !== void 0) {
			r.focus();
			for (let t of i.blocks) if (L(t, r, t.type, { textAlignment: R.textAlignment }) && B(r, t.type, { textAlignment: R.textAlignment })) r.updateBlock(t, { props: { textAlignment: e } });
			else if (t.type === "table") {
				let n = r.getExtension(P)?.getCellSelection();
				if (!n) continue;
				let i = t.content.rows.map((e) => ({
					...e,
					cells: e.cells.map((e) => U(e))
				}));
				n.cells.forEach(({ row: t, col: n }) => {
					i[t].cells[n].props.textAlignment = e;
				}), r.updateBlock(t, {
					type: "table",
					content: {
						...t.content,
						type: "tableContent",
						rows: i
					}
				}), r.setTextCursorPosition(t);
			}
		}
	}, [r, i]);
	if (i === void 0) return null;
	let o = In[e.textAlignment];
	return /* @__PURE__ */ K(t.FormattingToolbar.Button, {
		className: "bn-button",
		"data-test": `alignText${e.textAlignment.slice(0, 1).toUpperCase() + e.textAlignment.slice(1)}`,
		onClick: () => a(e.textAlignment),
		isSelected: i.textAlignment === e.textAlignment,
		label: n.formatting_toolbar[`align_${e.textAlignment}`].tooltip,
		mainTooltip: n.formatting_toolbar[`align_${e.textAlignment}`].tooltip,
		icon: /* @__PURE__ */ K(o, {})
	});
}, Rn = (e) => [
	/* @__PURE__ */ K(Dn, { items: e }, "blockTypeSelect"),
	/* @__PURE__ */ K(Fn, {}, "tableCellMergeButton"),
	/* @__PURE__ */ K(bn, {}, "fileCaptionButton"),
	/* @__PURE__ */ K(Cn, {}, "replaceFileButton"),
	/* @__PURE__ */ K(Sn, {}, "fileRenameButton"),
	/* @__PURE__ */ K(xn, {}, "fileDeleteButton"),
	/* @__PURE__ */ K(Mn, {}, "fileDownloadButton"),
	/* @__PURE__ */ K(Nn, {}, "filePreviewButton"),
	/* @__PURE__ */ K(J, { basicTextStyle: "bold" }, "boldStyleButton"),
	/* @__PURE__ */ K(J, { basicTextStyle: "italic" }, "italicStyleButton"),
	/* @__PURE__ */ K(J, { basicTextStyle: "underline" }, "underlineStyleButton"),
	/* @__PURE__ */ K(J, { basicTextStyle: "strike" }, "strikeStyleButton"),
	/* @__PURE__ */ K(Ln, { textAlignment: "left" }, "textAlignLeftButton"),
	/* @__PURE__ */ K(Ln, { textAlignment: "center" }, "textAlignCenterButton"),
	/* @__PURE__ */ K(Ln, { textAlignment: "right" }, "textAlignRightButton"),
	/* @__PURE__ */ K(hn, {}, "colorStyleButton"),
	/* @__PURE__ */ K(wn, {}, "nestBlockButton"),
	/* @__PURE__ */ K(Tn, {}, "unnestBlockButton"),
	/* @__PURE__ */ K(yn, {}, "createLinkButton"),
	/* @__PURE__ */ K(kn, {}, "addCommentButton"),
	/* @__PURE__ */ K(An, {}, "addTiptapCommentButton")
], zn = (e) => /* @__PURE__ */ K(s().FormattingToolbar.Root, {
	className: "bn-toolbar bn-formatting-toolbar",
	children: e.children || Rn(e.blockTypeSelectItems)
}), Bn = (e) => {
	switch (e) {
		case "left": return "top-start";
		case "center": return "top";
		case "right": return "top-end";
		default: return "top-start";
	}
}, Vn = (e) => {
	let t = c(), n = r(A, { editor: t }), i = u(A, { editor: t }), a = l({
		editor: t,
		selector: ({ editor: e }) => n.store.state ? {
			from: e.prosemirrorState.selection.from,
			to: e.prosemirrorState.selection.to
		} : void 0
	}), s = l({
		editor: t,
		selector: ({ editor: e }) => {
			let t = e.getTextCursorPosition().block;
			return L(t, e, t.type, { textAlignment: R.textAlignment }) ? Bn(t.props.textAlignment) : "top-start";
		}
	}), d = w(() => ({
		...e.floatingUIOptions,
		useFloatingOptions: {
			open: i,
			onOpenChange: (e, r, i) => {
				n.store.setState(e), i === "escape-key" && t.focus();
			},
			placement: s,
			middleware: [
				F(10),
				ye(),
				_e()
			],
			...e.floatingUIOptions?.useFloatingOptions
		},
		focusManagerProps: {
			disabled: !0,
			...e.floatingUIOptions?.focusManagerProps
		},
		elementProps: {
			style: { zIndex: 40 },
			...e.floatingUIOptions?.elementProps
		}
	}), [
		i,
		s,
		e.floatingUIOptions,
		n.store,
		t
	]), f = e.formattingToolbar || zn;
	return /* @__PURE__ */ K(o, {
		position: a,
		portalElement: e.portalElement,
		...d,
		children: i && /* @__PURE__ */ K(f, {})
	});
}, Hn = (e) => {
	let t = s(), n = f(), { deleteLink: i } = r(j);
	return /* @__PURE__ */ K(t.LinkToolbar.Button, {
		className: "bn-button",
		label: n.link_toolbar.delete.tooltip,
		mainTooltip: n.link_toolbar.delete.tooltip,
		isSelected: !1,
		onClick: () => {
			i(e.range.from), e.setToolbarOpen?.(!1);
		},
		icon: /* @__PURE__ */ K(kt, {})
	});
}, Un = (e) => {
	let t = s(), n = f();
	return /* @__PURE__ */ q(t.Generic.Popover.Root, {
		onOpenChange: e.setToolbarPositionFrozen,
		children: [/* @__PURE__ */ K(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ K(t.LinkToolbar.Button, {
			className: "bn-button",
			mainTooltip: n.link_toolbar.edit.tooltip,
			isSelected: !1,
			children: n.link_toolbar.edit.text
		}) }), /* @__PURE__ */ K(t.Generic.Popover.Content, {
			className: "bn-popover-content bn-form-popover",
			variant: "form-popover",
			children: /* @__PURE__ */ K(_n, {
				url: e.url,
				text: e.text,
				range: e.range,
				setToolbarOpen: e.setToolbarOpen,
				setToolbarPositionFrozen: e.setToolbarPositionFrozen
			})
		})]
	});
}, Wn = (e) => {
	let t = s(), n = f();
	return /* @__PURE__ */ K(t.LinkToolbar.Button, {
		className: "bn-button",
		mainTooltip: n.link_toolbar.open.tooltip,
		label: n.link_toolbar.open.tooltip,
		isSelected: !1,
		onClick: () => {
			window.open(jn(e.url, window.location.href), "_blank");
		},
		icon: /* @__PURE__ */ K(dt, {})
	});
}, Gn = (e) => /* @__PURE__ */ K(s().LinkToolbar.Root, {
	className: "bn-toolbar bn-link-toolbar",
	children: e.children || /* @__PURE__ */ q(G, { children: [
		/* @__PURE__ */ K(Un, {
			url: e.url,
			text: e.text,
			range: e.range,
			setToolbarOpen: e.setToolbarOpen,
			setToolbarPositionFrozen: e.setToolbarPositionFrozen
		}),
		/* @__PURE__ */ K(Wn, { url: e.url }),
		/* @__PURE__ */ K(Hn, {
			range: e.range,
			setToolbarOpen: e.setToolbarOpen
		})
	] })
}), Kn = (t) => {
	let n = c(), [i, a] = D(!1), [o, s] = D(!1), l = e(), u = r(j), [d, f] = D(void 0);
	C(() => {
		let e = () => {
			let e = u.getLinkAtSelection();
			if (!e) {
				f(void 0), o || a(!1);
				return;
			}
			f({
				cursorType: "text",
				url: e.mark.attrs.href,
				text: e.text,
				range: e.range,
				element: u.getLinkElementAtPos(e.range.from)
			}), o || a(!0);
		}, t = (e) => {
			if (d !== void 0 && d.cursorType === "text" || !(e.target instanceof HTMLElement)) return;
			let t = u.getLinkAtElement(e.target);
			t && f({
				cursorType: "mouse",
				url: t.mark.attrs.href,
				text: t.text,
				range: t.range,
				element: u.getLinkElementAtPos(t.range.from)
			});
		}, r = n.onChange(e), i = n.onSelectionChange(e);
		return l?.addEventListener("mouseover", t), () => {
			r(), i(), l?.removeEventListener("mouseover", t);
		};
	}, [
		n,
		l,
		u,
		d,
		o
	]);
	let m = w(() => ({
		...t.floatingUIOptions,
		useFloatingOptions: {
			open: i,
			onOpenChange: (e, t, r) => {
				o || d !== void 0 && d.cursorType === "text" && r === "hover" || (r === "escape-key" && n.focus(), a(e));
			},
			placement: "top-start",
			middleware: [F(10), _e()],
			...t.floatingUIOptions?.useFloatingOptions
		},
		useHoverProps: {
			enabled: d !== void 0 && d.cursorType === "mouse",
			delay: {
				open: 250,
				close: 250
			},
			handleClose: ve(),
			...t.floatingUIOptions?.useHoverProps
		},
		focusManagerProps: {
			disabled: !0,
			...t.floatingUIOptions?.focusManagerProps
		},
		elementProps: {
			style: { zIndex: 50 },
			...t.floatingUIOptions?.elementProps
		}
	}), [
		n,
		d,
		t.floatingUIOptions,
		i,
		o
	]), h = w(() => d?.element ? { element: d.element } : void 0, [d?.element]);
	if (!n.isEditable) return null;
	let g = t.linkToolbar || Gn;
	return /* @__PURE__ */ K(p, {
		reference: h,
		portalElement: t.portalElement,
		...m,
		children: d && /* @__PURE__ */ K(g, {
			url: d.url,
			text: d.text,
			range: d.range,
			setToolbarOpen: a,
			setToolbarPositionFrozen: s
		})
	});
}, qn = () => {
	let e = s(), t = f(), n = c(), i = r(N), a = u(M, {
		editor: n,
		selector: (e) => e?.block
	}), o = S(() => {
		if (a === void 0) return;
		let e = a.content;
		if (e !== void 0 && Array.isArray(e) && e.length === 0) n.setTextCursorPosition(a), i.openSuggestionMenu("/");
		else {
			let e = n.insertBlocks([{ type: "paragraph" }], a, "after")[0];
			n.setTextCursorPosition(e), i.openSuggestionMenu("/");
		}
	}, [
		a,
		n,
		i
	]);
	return a === void 0 ? null : /* @__PURE__ */ K(e.SideMenu.Button, {
		className: "bn-button",
		label: t.side_menu.add_block_label,
		icon: /* @__PURE__ */ K(Wt, {
			size: 24,
			onClick: o,
			"data-test": "dragHandleAdd"
		})
	});
}, Jn = (e) => {
	let t = s(), n = c(), r = u(M, {
		editor: n,
		selector: (e) => e?.block
	});
	return r === void 0 || !L(r, n, r.type, { textColor: "string" }) && !L(r, n, r.type, { backgroundColor: "string" }) ? null : /* @__PURE__ */ q(t.Generic.Menu.Root, {
		position: "right",
		sub: !0,
		children: [/* @__PURE__ */ K(t.Generic.Menu.Trigger, {
			sub: !0,
			children: /* @__PURE__ */ K(t.Generic.Menu.Item, {
				className: "bn-menu-item",
				subTrigger: !0,
				children: e.children
			})
		}), /* @__PURE__ */ K(t.Generic.Menu.Dropdown, {
			sub: !0,
			className: "bn-menu-dropdown bn-color-picker-dropdown",
			children: /* @__PURE__ */ K(pn, {
				iconSize: 18,
				text: L(r, n, r.type, { textColor: "string" }) && B(n, r.type, { textColor: "string" }) ? {
					color: r.props.textColor,
					setColor: (e) => n.updateBlock(r, {
						type: r.type,
						props: { textColor: e }
					})
				} : void 0,
				background: L(r, n, r.type, { backgroundColor: "string" }) && B(n, r.type, { backgroundColor: "string" }) ? {
					color: r.props.backgroundColor,
					setColor: (e) => n.updateBlock(r, { props: { backgroundColor: e } })
				} : void 0
			})
		})]
	});
}, Yn = (e) => {
	let t = s(), n = c(), r = u(M, {
		editor: n,
		selector: (e) => e?.block
	});
	return r === void 0 ? null : /* @__PURE__ */ K(t.Generic.Menu.Item, {
		className: "bn-menu-item",
		onClick: () => {
			let e = n.getSelection()?.blocks, t = e && e.some((e) => e.id === r.id) ? e : [r];
			n.removeBlocks(t);
		},
		children: e.children
	});
}, Xn = (e) => {
	let t = s(), n = c(), r = u(M, {
		editor: n,
		selector: (e) => e?.block
	});
	if (r === void 0 || r.type !== "table" || !n.settings.tables.headers) return null;
	let i = !!r.content.headerRows;
	return /* @__PURE__ */ K(t.Generic.Menu.Item, {
		className: "bn-menu-item",
		checked: i,
		onClick: () => {
			n.updateBlock(r, { content: {
				...r.content,
				headerRows: i ? void 0 : 1
			} });
		},
		children: e.children
	});
}, Zn = (e) => {
	let t = s(), n = c(), r = u(M, {
		editor: n,
		selector: (e) => e?.block
	});
	if (r === void 0 || r.type !== "table" || !n.settings.tables.headers) return null;
	let i = !!r.content.headerCols;
	return /* @__PURE__ */ K(t.Generic.Menu.Item, {
		className: "bn-menu-item",
		checked: i,
		onClick: () => {
			n.updateBlock(r, { content: {
				...r.content,
				headerCols: i ? void 0 : 1
			} });
		},
		children: e.children
	});
}, Qn = (e) => {
	let t = s(), n = f();
	return /* @__PURE__ */ K(t.Generic.Menu.Dropdown, {
		className: "bn-menu-dropdown bn-drag-handle-menu",
		children: e.children || /* @__PURE__ */ q(G, { children: [
			/* @__PURE__ */ K(Yn, { children: n.drag_handle.delete_menuitem }),
			/* @__PURE__ */ K(Jn, { children: n.drag_handle.colors_menuitem }),
			/* @__PURE__ */ K(Xn, { children: n.drag_handle.header_row_menuitem }),
			/* @__PURE__ */ K(Zn, { children: n.drag_handle.header_column_menuitem })
		] })
	});
}, $n = (e) => {
	let t = s(), n = f(), i = r(M), a = u(M, { selector: (e) => e?.block });
	if (a === void 0) return null;
	let o = e.dragHandleMenu || Qn;
	return /* @__PURE__ */ q(t.Generic.Menu.Root, {
		onOpenChange: (e) => {
			e ? i.freezeMenu() : i.unfreezeMenu();
		},
		position: "left",
		children: [/* @__PURE__ */ K(t.Generic.Menu.Trigger, { children: /* @__PURE__ */ K(t.SideMenu.Button, {
			label: n.side_menu.drag_handle_label,
			draggable: !0,
			onDragStart: (e) => i.blockDragStart(e, a),
			onDragEnd: i.blockDragEnd,
			className: "bn-button",
			icon: /* @__PURE__ */ K(Kt, {
				size: 24,
				"data-test": "dragHandle"
			})
		}) }), /* @__PURE__ */ K(o, { children: e.children })]
	});
}, er = (e) => {
	let t = s(), n = c(), r = u(M, {
		editor: n,
		selector: (e) => e?.block
	}), i = w(() => {
		if (r === void 0) return {};
		let e = { "data-block-type": r.type };
		return r.type === "heading" && (e["data-level"] = r.props.level.toString()), n.schema.blockSpecs[r.type].implementation.meta?.fileBlockAccept && (r.props.url ? e["data-url"] = "true" : e["data-url"] = "false"), e;
	}, [r, n.schema.blockSpecs]);
	return /* @__PURE__ */ K(t.SideMenu.Root, {
		className: "bn-side-menu",
		...i,
		children: e.children || /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(qn, {}), /* @__PURE__ */ K($n, { dragHandleMenu: e.dragHandleMenu })] })
	});
}, tr = (e) => {
	let t = c(), { show: n, block: r } = u(M, { selector: (e) => e === void 0 ? void 0 : {
		show: e.show,
		block: e.block
	} }) || {}, i = S((e, n, r) => {
		let i = !1;
		return ge(e, n, () => {
			if (!i) {
				i = !0;
				return;
			}
			t.getExtension(M)?.hideMenuIfNotFrozen();
		}, {
			ancestorScroll: !0,
			ancestorResize: !1,
			elementResize: !1,
			layoutShift: !1
		});
	}, [t]), a = w(() => ({
		...e.floatingUIOptions,
		useFloatingOptions: {
			open: n,
			placement: "left-start",
			whileElementsMounted: i,
			...e.floatingUIOptions?.useFloatingOptions
		},
		useDismissProps: {
			enabled: !1,
			...e.floatingUIOptions?.useDismissProps
		},
		focusManagerProps: {
			disabled: !0,
			...e.floatingUIOptions?.focusManagerProps
		},
		elementProps: {
			style: { zIndex: 20 },
			...e.floatingUIOptions?.elementProps
		}
	}), [
		e.floatingUIOptions,
		n,
		i
	]), o = e.sideMenu || er;
	return /* @__PURE__ */ K(rn, {
		blockId: n ? r?.id : void 0,
		portalElement: e.portalElement,
		...a,
		children: r?.id && /* @__PURE__ */ K(o, {})
	});
};
//#endregion
//#region src/components/SuggestionMenu/GridSuggestionMenu/getDefaultReactEmojiPickerItems.tsx
async function nr(e, t) {
	return (await pe(e, t)).map(({ id: e, onItemClick: t }) => ({
		id: e,
		onItemClick: t,
		icon: e
	}));
}
//#endregion
//#region src/components/SuggestionMenu/GridSuggestionMenu/GridSuggestionMenu.tsx
function rr(e) {
	let t = s(), n = f(), { items: r, loadingState: i, selectedIndex: a, onItemClick: o, columns: c } = e, l = i === "loading-initial" || i === "loading" ? /* @__PURE__ */ K(t.GridSuggestionMenu.Loader, {
		className: "bn-grid-suggestion-menu-loader",
		columns: c
	}) : null, u = w(() => {
		let e = [];
		for (let n = 0; n < r.length; n++) {
			let i = r[n];
			e.push(/* @__PURE__ */ K(t.GridSuggestionMenu.Item, {
				className: "bn-grid-suggestion-menu-item",
				item: i,
				id: `bn-grid-suggestion-menu-item-${n}`,
				isSelected: n === a,
				onClick: () => o?.(i)
			}, i.id));
		}
		return e;
	}, [
		t,
		r,
		o,
		a
	]);
	return /* @__PURE__ */ q(t.GridSuggestionMenu.Root, {
		id: "bn-grid-suggestion-menu",
		columns: c,
		className: "bn-grid-suggestion-menu",
		children: [
			l,
			u,
			u.length === 0 && e.loadingState === "loaded" && /* @__PURE__ */ K(t.GridSuggestionMenu.EmptyItem, {
				className: "bn-grid-suggestion-menu-empty-item",
				columns: c,
				children: n.suggestion_menu.no_items_title
			})
		]
	});
}
//#endregion
//#region src/components/SuggestionMenu/hooks/useCloseSuggestionMenuNoItems.ts
function ir(e, t, n, r = 3) {
	let i = E(0);
	C(() => {
		t !== void 0 && (e.length > 0 ? i.current = t.length : t.length - i.current > r && n());
	}, [
		n,
		r,
		e.length,
		t
	]);
}
//#endregion
//#region src/components/SuggestionMenu/hooks/useLoadSuggestionMenuItems.ts
function ar(e, t) {
	let [n, r] = D([]), [i, a] = D(!1), o = E(void 0), s = E(void 0);
	return C(() => {
		let n = e;
		o.current = e, a(!0), t(e).then((e) => {
			o.current === n && (r(e), a(!1), s.current = n);
		});
	}, [e, t]), {
		items: n || [],
		usedQuery: s.current,
		loadingState: s.current === void 0 ? "loading-initial" : i ? "loading" : "loaded"
	};
}
//#endregion
//#region src/components/SuggestionMenu/GridSuggestionMenu/hooks/useGridSuggestionMenuKeyboardNavigation.ts
function or(t, n, r, i, a) {
	let o = e(t), [s, c] = D(0);
	return C(() => {
		let e = (e) => (e.key === "ArrowLeft" && (e.preventDefault(), r.length && c((s - 1 + r.length) % r.length)), e.key === "ArrowRight" && (e.preventDefault(), r.length && c((s + 1 + r.length) % r.length)), e.key === "ArrowUp" ? (e.preventDefault(), r.length && c((s - i + r.length) % r.length), !0) : e.key === "ArrowDown" ? (e.preventDefault(), r.length && c((s + i) % r.length), !0) : e.key === "Enter" && !e.isComposing ? (e.stopPropagation(), e.preventDefault(), r.length && a?.(r[s]), !0) : !1);
		return o?.addEventListener("keydown", e, !0), () => {
			o?.removeEventListener("keydown", e, !0);
		};
	}, [
		o,
		r,
		s,
		a,
		i,
		i !== void 0 && i > 1
	]), C(() => {
		c(0);
	}, [n]), { selectedIndex: r.length === 0 ? void 0 : s };
}
//#endregion
//#region src/components/SuggestionMenu/GridSuggestionMenu/GridSuggestionMenuWrapper.tsx
function sr(e) {
	let t = i().setContentEditableProps, n = c(), { getItems: r, gridSuggestionMenuComponent: a, query: o, clearQuery: s, closeMenu: l, onItemClick: u, columns: d } = e, f = S((e) => {
		l(), s(), u?.(e);
	}, [
		u,
		l,
		s
	]), { items: p, usedQuery: m, loadingState: h } = ar(o, r);
	ir(p, m, l);
	let { selectedIndex: g } = or(n, o, p, d, f);
	return C(() => (t((e) => ({
		...e,
		"aria-expanded": !0,
		"aria-controls": "bn-suggestion-menu"
	})), () => {
		t((e) => ({
			...e,
			"aria-expanded": !1,
			"aria-controls": void 0
		}));
	}), [t]), C(() => (t((e) => ({
		...e,
		"aria-activedescendant": g ? "bn-suggestion-menu-item-" + g : void 0
	})), () => {
		t((e) => ({
			...e,
			"aria-activedescendant": void 0
		}));
	}), [t, g]), /* @__PURE__ */ K(a, {
		items: p,
		onItemClick: f,
		loadingState: h,
		selectedIndex: g,
		columns: d
	});
}
//#endregion
//#region src/components/SuggestionMenu/GridSuggestionMenu/GridSuggestionMenuController.tsx
function cr(t) {
	let n = c(), i = e(), { triggerCharacter: a, gridSuggestionMenuComponent: o, columns: s, shouldOpen: l, minQueryLength: d, onItemClick: f, getItems: m } = t, h = w(() => f || ((e) => {
		e.onItemClick(n);
	}), [n, f]), g = w(() => m || (async (e) => await nr(n, e)), [n, m]), _ = r(N);
	C(() => {
		_.addSuggestionMenu({
			triggerCharacter: a,
			shouldOpen: l
		});
	}, [
		_,
		a,
		l
	]);
	let v = u(N), y = u(N, { selector: (e) => ({
		element: i?.firstChild || void 0,
		getBoundingClientRect: () => e?.referencePos || new DOMRect()
	}) }), b = w(() => ({
		...t.floatingUIOptions,
		useFloatingOptions: {
			open: v?.show && v?.triggerCharacter === a,
			onOpenChange: (e) => {
				e || _.closeMenu();
			},
			placement: "bottom-start",
			middleware: [
				F(10),
				he({
					allowedPlacements: ["bottom-start", "top-start"],
					padding: 10
				}),
				ye(),
				I({
					apply({ elements: e, availableHeight: t }) {
						e.floating.style.maxHeight = `${Math.max(0, t)}px`;
					},
					padding: 10
				})
			],
			...t.floatingUIOptions?.useFloatingOptions
		},
		focusManagerProps: {
			disabled: !0,
			...t.floatingUIOptions?.focusManagerProps
		},
		elementProps: {
			onMouseDownCapture: (e) => e.preventDefault(),
			style: { zIndex: 70 },
			...t.floatingUIOptions?.elementProps
		}
	}), [
		t.floatingUIOptions,
		v?.show,
		v?.triggerCharacter,
		_,
		a
	]);
	return !v || !v.ignoreQueryLength && d && (v.query.startsWith(" ") || v.query.length < d) ? null : /* @__PURE__ */ K(p, {
		reference: y,
		portalElement: t.portalElement,
		...b,
		children: a && /* @__PURE__ */ K(sr, {
			query: v.query,
			closeMenu: _.closeMenu,
			clearQuery: _.clearQuery,
			getItems: g,
			columns: s,
			gridSuggestionMenuComponent: o || rr,
			onItemClick: h
		})
	});
}
//#endregion
//#region src/components/SuggestionMenu/SuggestionMenu.tsx
function lr(e) {
	let t = s(), n = f(), { items: r, loadingState: i, selectedIndex: a, onItemClick: o } = e, c = i === "loading-initial" || i === "loading" ? /* @__PURE__ */ K(t.SuggestionMenu.Loader, { className: "bn-suggestion-menu-loader" }) : null, l = w(() => {
		let e, n = [];
		for (let i = 0; i < r.length; i++) {
			let s = r[i];
			s.group !== e && (e = s.group, n.push(/* @__PURE__ */ K(t.SuggestionMenu.Label, {
				className: "bn-suggestion-menu-label",
				children: e
			}, e))), n.push(/* @__PURE__ */ K(t.SuggestionMenu.Item, {
				className: W("bn-suggestion-menu-item", s.size === "small" ? "bn-suggestion-menu-item-small" : ""),
				item: s,
				id: `bn-suggestion-menu-item-${i}`,
				isSelected: i === a,
				onClick: () => o?.(s)
			}, s.title));
		}
		return n;
	}, [
		t,
		r,
		o,
		a
	]);
	return /* @__PURE__ */ q(t.SuggestionMenu.Root, {
		id: "bn-suggestion-menu",
		className: "bn-suggestion-menu",
		children: [
			l,
			l.length === 0 && (e.loadingState === "loading" || e.loadingState === "loaded") && /* @__PURE__ */ K(t.SuggestionMenu.EmptyItem, {
				className: "bn-suggestion-menu-item",
				children: n.suggestion_menu.no_items_title
			}),
			c
		]
	});
}
//#endregion
//#region src/components/SuggestionMenu/hooks/useSuggestionMenuKeyboardHandler.ts
function ur(e, t) {
	let [n, r] = D(0);
	return {
		selectedIndex: n,
		setSelectedIndex: r,
		handler: (i) => {
			if (i.key === "ArrowUp") return i.preventDefault(), e.length && r((n - 1 + e.length) % e.length), !0;
			if (i.key === "ArrowDown") return i.preventDefault(), e.length && r((n + 1) % e.length), !0;
			if (i.key === "PageUp") return i.preventDefault(), e.length && r(0), !0;
			if (i.key === "PageDown") return i.preventDefault(), e.length && r(e.length - 1), !0;
			let a = dr(i) ? i.nativeEvent.isComposing : i.isComposing;
			return i.key === "Enter" && !a ? (i.preventDefault(), i.stopPropagation(), e.length && t?.(e[n]), !0) : !1;
		}
	};
}
function dr(e) {
	return e.nativeEvent !== void 0;
}
//#endregion
//#region src/components/SuggestionMenu/hooks/useSuggestionMenuKeyboardNavigation.ts
function fr(t, n, r, i, a) {
	let o = e(), { selectedIndex: s, setSelectedIndex: c, handler: l } = ur(r, i);
	return C(() => {
		let e = a || o;
		return e?.addEventListener("keydown", l, !0), () => {
			e?.removeEventListener("keydown", l, !0);
		};
	}, [
		o,
		r,
		s,
		i,
		a,
		l
	]), C(() => {
		c(0);
	}, [n, c]), { selectedIndex: r.length === 0 ? void 0 : s };
}
//#endregion
//#region src/components/SuggestionMenu/SuggestionMenuWrapper.tsx
function pr(e) {
	let t = i().setContentEditableProps, n = c(), { getItems: r, suggestionMenuComponent: a, query: o, clearQuery: s, closeMenu: l, onItemClick: u } = e, d = S((e) => {
		l(), s(), u?.(e);
	}, [
		u,
		l,
		s
	]), { items: f, usedQuery: p, loadingState: m } = ar(o, r);
	ir(f, p, l);
	let { selectedIndex: h } = fr(n, o, f, d);
	return C(() => (t((e) => ({
		...e,
		"aria-expanded": !0,
		"aria-controls": "bn-suggestion-menu"
	})), () => {
		t((e) => ({
			...e,
			"aria-expanded": !1,
			"aria-controls": void 0
		}));
	}), [t]), C(() => (t((e) => ({
		...e,
		"aria-activedescendant": h ? "bn-suggestion-menu-item-" + h : void 0
	})), () => {
		t((e) => ({
			...e,
			"aria-activedescendant": void 0
		}));
	}), [t, h]), /* @__PURE__ */ K(a, {
		items: f,
		onItemClick: d,
		loadingState: m,
		selectedIndex: h
	});
}
//#endregion
//#region src/components/SuggestionMenu/getDefaultReactSlashMenuItems.tsx
var mr = {
	heading: ht,
	heading_2: gt,
	heading_3: _t,
	heading_4: vt,
	heading_5: yt,
	heading_6: bt,
	toggle_heading: ht,
	toggle_heading_2: gt,
	toggle_heading_3: _t,
	quote: It,
	toggle_list: Ft,
	numbered_list: jt,
	bullet_list: Mt,
	check_list: At,
	paragraph: Bt,
	table: zt,
	image: xt,
	video: pt,
	audio: Ut,
	file: ft,
	emoji: ut,
	code_block: ot,
	divider: Rt
};
function hr(e) {
	return me(e).map((e) => {
		let t = mr[e.key];
		return {
			...e,
			icon: /* @__PURE__ */ K(t, { size: 18 })
		};
	});
}
//#endregion
//#region src/components/SuggestionMenu/SuggestionMenuController.tsx
function gr(t) {
	let n = c(), i = e(), { triggerCharacter: a, suggestionMenuComponent: o, shouldOpen: s, minQueryLength: l, onItemClick: d, getItems: f } = t, m = w(() => d || ((e) => {
		e.onItemClick(n);
	}), [n, d]), h = w(() => f || (async (e) => fe(hr(n), e)), [n, f]), g = r(N);
	C(() => {
		g.addSuggestionMenu({
			triggerCharacter: a,
			shouldOpen: s
		});
	}, [
		g,
		a,
		s
	]);
	let _ = u(N), v = u(N, { selector: (e) => ({
		element: i?.firstChild || void 0,
		getBoundingClientRect: () => e?.referencePos || new DOMRect()
	}) }), y = w(() => ({
		...t.floatingUIOptions,
		useFloatingOptions: {
			open: _?.show && _?.triggerCharacter === a,
			onOpenChange: (e) => {
				e || g.closeMenu();
			},
			placement: "bottom-start",
			middleware: [
				F(10),
				he({
					allowedPlacements: ["bottom-start", "top-start"],
					padding: 10
				}),
				ye(),
				I({
					apply({ elements: e, availableHeight: t }) {
						e.floating.style.maxHeight = `${Math.max(0, t)}px`;
					},
					padding: 10
				})
			],
			...t.floatingUIOptions?.useFloatingOptions
		},
		focusManagerProps: {
			disabled: !0,
			...t.floatingUIOptions?.focusManagerProps
		},
		elementProps: {
			onMouseDownCapture: (e) => e.preventDefault(),
			style: { zIndex: 80 },
			...t.floatingUIOptions?.elementProps
		}
	}), [
		t.floatingUIOptions,
		_?.show,
		_?.triggerCharacter,
		g,
		a
	]);
	return !_ || !_.ignoreQueryLength && l && (_.query.startsWith(" ") || _.query.length < l) ? null : /* @__PURE__ */ K(p, {
		reference: v,
		portalElement: t.portalElement,
		...y,
		children: a && /* @__PURE__ */ K(pr, {
			query: _.query,
			closeMenu: g.closeMenu,
			clearQuery: g.clearQuery,
			getItems: h,
			suggestionMenuComponent: o || lr,
			onItemClick: m
		})
	});
}
//#endregion
//#region src/components/TableHandles/ExtendButton/ExtendButton.tsx
var _r = (e, t = .3) => {
	let n = Math.floor(e) + t, r = Math.ceil(e) - t;
	return e >= n && e <= r ? Math.round(e) : e < n ? Math.floor(e) : Math.ceil(e);
}, vr = (e) => {
	let t = s(), n = c(), i = r(P), a = u(P, { selector: (e) => e?.block }), o = E(!1), [l, d] = D(), f = S((t) => {
		i.freezeHandles(), e.hideOtherElements(!0), a && (d({
			originalContent: a.content,
			originalCroppedContent: { rows: i.cropEmptyRowsOrColumns(a, e.orientation === "addOrRemoveColumns" ? "columns" : "rows") },
			startPos: e.orientation === "addOrRemoveColumns" ? t.clientX : t.clientY
		}), o.current = !1, t.preventDefault());
	}, [
		a,
		e,
		i
	]), p = S(() => {
		!a || o.current || n.updateBlock(a, {
			type: "table",
			content: {
				...a.content,
				rows: e.orientation === "addOrRemoveColumns" ? i.addRowsOrColumns(a, "columns", 1) : i.addRowsOrColumns(a, "rows", 1)
			}
		});
	}, [
		a,
		n,
		e.orientation,
		i
	]);
	return C(() => {
		let t = (t) => {
			if (!a) return;
			if (!l) throw Error("editingState is undefined");
			o.current = !0;
			let r = (e.orientation === "addOrRemoveColumns" ? t.clientX : t.clientY) - l.startPos, s = e.orientation === "addOrRemoveColumns" ? l.originalCroppedContent.rows[0]?.cells.length ?? 0 : l.originalCroppedContent.rows.length, c = e.orientation === "addOrRemoveColumns" ? l.originalContent.rows[0]?.cells.length ?? 0 : l.originalContent.rows.length, u = e.orientation === "addOrRemoveColumns" ? a.content.rows[0].cells.length : a.content.rows.length, d = c + _r(r / (e.orientation === "addOrRemoveColumns" ? Ce : Se), .3);
			d >= s && d > 0 && d !== u && (n.updateBlock(a, {
				type: "table",
				content: {
					...a.content,
					rows: e.orientation === "addOrRemoveColumns" ? i.addRowsOrColumns({
						type: "table",
						content: l.originalCroppedContent
					}, "columns", d - s) : i.addRowsOrColumns({
						type: "table",
						content: l.originalCroppedContent
					}, "rows", d - s)
				}
			}), a.content && n.setTextCursorPosition(a));
		};
		return l && window.addEventListener("mousemove", t), () => {
			window.removeEventListener("mousemove", t);
		};
	}, [
		a,
		l,
		n,
		e.orientation,
		i
	]), C(() => {
		let t = () => {
			e.hideOtherElements(!1), i.unfreezeHandles(), d(void 0);
		};
		return l && window.addEventListener("mouseup", t), () => {
			window.removeEventListener("mouseup", t);
		};
	}, [
		l,
		e,
		i
	]), n.isEditable ? /* @__PURE__ */ K(t.TableHandle.ExtendButton, {
		className: W("bn-extend-button", e.orientation === "addOrRemoveColumns" ? "bn-extend-button-add-remove-columns" : "bn-extend-button-add-remove-rows", l === null ? "" : "bn-extend-button-editing"),
		onClick: p,
		onMouseDown: f,
		children: e.children || /* @__PURE__ */ K($e, {
			size: 18,
			"data-test": "extendButton"
		})
	}) : null;
}, yr = (e) => {
	let t = s(), n = f(), r = c(), { block: i, colIndex: a, rowIndex: o } = u(P, { selector: (e) => ({
		block: e?.block,
		colIndex: e?.colIndex,
		rowIndex: e?.rowIndex
	}) }), l = (e, t) => {
		if (i === void 0 || a === void 0 || o === void 0) return;
		let n = i.content.rows.map((e) => ({
			...e,
			cells: e.cells.map((e) => U(e))
		}));
		t === "text" ? n[o].cells[a].props.textColor = e : n[o].cells[a].props.backgroundColor = e, r.updateBlock(i, {
			type: "table",
			content: {
				...i.content,
				rows: n
			}
		}), r.setTextCursorPosition(i);
	};
	if (i === void 0 || a === void 0 || o === void 0) return null;
	let d = i.content.rows[o]?.cells?.[a];
	return !d || r.settings.tables.cellTextColor === !1 && r.settings.tables.cellBackgroundColor === !1 ? null : /* @__PURE__ */ q(t.Generic.Menu.Root, {
		position: "right",
		sub: !0,
		children: [/* @__PURE__ */ K(t.Generic.Menu.Trigger, {
			sub: !0,
			children: /* @__PURE__ */ K(t.Generic.Menu.Item, {
				className: "bn-menu-item",
				subTrigger: !0,
				children: e.children || n.drag_handle.colors_menuitem
			})
		}), /* @__PURE__ */ K(t.Generic.Menu.Dropdown, {
			sub: !0,
			className: "bn-menu-dropdown bn-color-picker-dropdown",
			children: /* @__PURE__ */ K(pn, {
				iconSize: 18,
				text: r.settings.tables.cellTextColor ? {
					color: H(d) ? d.props.textColor : "default",
					setColor: (e) => l(e, "text")
				} : void 0,
				background: r.settings.tables.cellBackgroundColor ? {
					color: H(d) ? d.props.backgroundColor : "default",
					setColor: (e) => l(e, "background")
				} : void 0
			})
		})]
	});
}, br = () => {
	let e = s(), t = f(), n = c(), i = r(P), { block: a, colIndex: o, rowIndex: l } = u(P, { selector: (e) => ({
		block: e?.block,
		colIndex: e?.colIndex,
		rowIndex: e?.rowIndex
	}) });
	if (a === void 0 || o === void 0 || l === void 0) return null;
	let d = a.content.rows[l]?.cells?.[o];
	return !d || !H(d) || Ue(d) === 1 && ze(d) === 1 || !n.settings.tables.splitCells ? null : /* @__PURE__ */ K(e.Generic.Menu.Item, {
		onClick: () => {
			i.splitCell({
				row: l,
				col: o
			});
		},
		children: t.table_handle.split_cell_menuitem
	});
}, xr = (e) => /* @__PURE__ */ K(s().Generic.Menu.Dropdown, {
	className: "bn-menu-dropdown bn-table-handle-menu",
	children: e.children || /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(br, {}), /* @__PURE__ */ K(yr, {})] })
}), Sr = (e) => {
	let t = s(), n = c(), i = r(P), a = e.tableCellMenu || xr;
	return !n.settings.tables.splitCells && !n.settings.tables.cellBackgroundColor && !n.settings.tables.cellTextColor ? null : /* @__PURE__ */ q(t.Generic.Menu.Root, {
		onOpenChange: (t) => {
			t ? (i.freezeHandles(), e.hideOtherElements(!0)) : (i.unfreezeHandles(), e.hideOtherElements(!1), n.focus());
		},
		position: "right",
		children: [/* @__PURE__ */ K(t.Generic.Menu.Trigger, { children: /* @__PURE__ */ K(t.Generic.Menu.Button, {
			className: "bn-table-cell-handle",
			children: e.children || /* @__PURE__ */ K(Gt, {
				size: 12,
				"data-test": "tableCellHandle"
			})
		}) }), /* @__PURE__ */ K(a, {})]
	});
}, Cr = (e) => {
	let t = s(), n = f(), i = r(P), a = u(P, { selector: (t) => e.orientation === "column" ? t?.colIndex : t?.rowIndex });
	return i === void 0 || a === void 0 ? null : /* @__PURE__ */ K(t.Generic.Menu.Item, {
		onClick: () => {
			i.addRowOrColumn(a, e.orientation === "row" ? {
				orientation: "row",
				side: e.side
			} : {
				orientation: "column",
				side: e.side
			});
		},
		children: n.table_handle[`add_${e.side}_menuitem`]
	});
}, wr = (e) => {
	let t = s(), n = f(), i = r(P), a = u(P, { selector: (t) => e.orientation === "column" ? t?.colIndex : t?.rowIndex });
	return i === void 0 || a === void 0 ? null : /* @__PURE__ */ K(t.Generic.Menu.Item, {
		onClick: () => i.removeRowOrColumn(a, e.orientation),
		children: e.orientation === "row" ? n.table_handle.delete_row_menuitem : n.table_handle.delete_column_menuitem
	});
}, Tr = (e) => {
	let t = s(), n = f(), i = c(), a = r(P), { block: o, index: l } = u(P, { selector: (t) => ({
		block: t?.block,
		index: e.orientation === "column" ? t?.colIndex : t?.rowIndex
	}) }), d = w(() => a === void 0 || o === void 0 || l === void 0 ? [] : e.orientation === "row" ? a.getCellsAtRowHandle(o, l) : a.getCellsAtColumnHandle(o, l), [
		o,
		l,
		e.orientation,
		a
	]), p = (e, t) => {
		if (o === void 0) return;
		let n = o.content.rows.map((e) => ({
			...e,
			cells: e.cells.map((e) => U(e))
		}));
		d.forEach(({ row: r, col: i }) => {
			t === "text" ? n[r].cells[i].props.textColor = e : n[r].cells[i].props.backgroundColor = e;
		}), i.updateBlock(o, {
			type: "table",
			content: {
				...o.content,
				rows: n
			}
		}), i.setTextCursorPosition(o);
	};
	if (!d || !d[0] || !a || i.settings.tables.cellTextColor === !1 && i.settings.tables.cellBackgroundColor === !1) return null;
	let m = U(d[0].cell);
	return /* @__PURE__ */ q(t.Generic.Menu.Root, {
		position: "right",
		sub: !0,
		children: [/* @__PURE__ */ K(t.Generic.Menu.Trigger, {
			sub: !0,
			children: /* @__PURE__ */ K(t.Generic.Menu.Item, {
				className: "bn-menu-item",
				subTrigger: !0,
				children: e.children || n.drag_handle.colors_menuitem
			})
		}), /* @__PURE__ */ K(t.Generic.Menu.Dropdown, {
			sub: !0,
			className: "bn-menu-dropdown bn-color-picker-dropdown",
			children: /* @__PURE__ */ K(pn, {
				iconSize: 18,
				text: i.settings.tables.cellTextColor ? {
					color: d.every(({ cell: e }) => H(e) && e.props.textColor === m.props.textColor) ? m.props.textColor : "default",
					setColor: (e) => {
						p(e, "text");
					}
				} : void 0,
				background: i.settings.tables.cellBackgroundColor ? {
					color: d.every(({ cell: e }) => H(e) && e.props.backgroundColor === m.props.backgroundColor) ? m.props.backgroundColor : "default",
					setColor: (e) => p(e, "background")
				} : void 0
			})
		})]
	});
}, Er = (e) => {
	let t = s(), n = f(), i = c(), a = r(P), { block: o, index: l } = u(P, { selector: (t) => ({
		block: t?.block,
		index: e.orientation === "column" ? t?.colIndex : t?.rowIndex
	}) });
	if (a === void 0 || o === void 0 || l !== 0 || e.orientation !== "row" || !i.settings.tables.headers) return null;
	let d = !!o.content.headerRows;
	return /* @__PURE__ */ K(t.Generic.Menu.Item, {
		className: "bn-menu-item",
		checked: d,
		onClick: () => {
			i.updateBlock(o, {
				...o,
				content: {
					...o.content,
					headerRows: d ? void 0 : 1
				}
			});
		},
		children: n.drag_handle.header_row_menuitem
	});
}, Dr = (e) => {
	let t = s(), n = f(), i = c(), a = r(P), o = u(P, { selector: (e) => e?.block }), l = u(P, { selector: (t) => e.orientation === "column" ? t?.colIndex : t?.rowIndex });
	if (!a || l !== 0 || !o || e.orientation !== "column" || !i.settings.tables.headers) return null;
	let d = !!o.content.headerCols;
	return /* @__PURE__ */ K(t.Generic.Menu.Item, {
		className: "bn-menu-item",
		checked: d,
		onClick: () => {
			i.updateBlock(o, {
				...o,
				content: {
					...o.content,
					headerCols: d ? void 0 : 1
				}
			});
		},
		children: n.drag_handle.header_column_menuitem
	});
}, Or = (e) => /* @__PURE__ */ K(s().Generic.Menu.Dropdown, {
	className: "bn-table-handle-menu",
	children: e.children || /* @__PURE__ */ q(G, { children: [
		/* @__PURE__ */ K(wr, { orientation: e.orientation }),
		/* @__PURE__ */ K(Cr, {
			orientation: e.orientation,
			side: e.orientation === "row" ? "above" : "left"
		}),
		/* @__PURE__ */ K(Cr, {
			orientation: e.orientation,
			side: e.orientation === "row" ? "below" : "right"
		}),
		/* @__PURE__ */ K(Er, { orientation: e.orientation }),
		/* @__PURE__ */ K(Dr, { orientation: e.orientation }),
		/* @__PURE__ */ K(Tr, { orientation: e.orientation })
	] })
}), kr = (e) => {
	let t = c(), n = s(), [i, a] = D(!1), o = e.tableHandleMenu || Or, l = r(P), d = u(P), f = w(() => !l || !d || !d.block || d.block.type !== "table" ? !1 : e.orientation === "column" ? l.getCellsAtColumnHandle(d.block, d.colIndex).every(({ cell: e }) => ze(e) === 1) : l.getCellsAtRowHandle(d.block, d.rowIndex).every(({ cell: e }) => Ue(e) === 1), [
		e.orientation,
		d,
		l
	]);
	return d ? /* @__PURE__ */ q(n.Generic.Menu.Root, {
		onOpenChange: (n) => {
			n ? (l.freezeHandles(), e.hideOtherElements(!0)) : (l.unfreezeHandles(), e.hideOtherElements(!1), t.focus());
		},
		position: "right",
		children: [/* @__PURE__ */ K(n.Generic.Menu.Trigger, { children: /* @__PURE__ */ K(n.TableHandle.Root, {
			className: W("bn-table-handle", i ? "bn-table-handle-dragging" : "", f ? "" : "bn-table-handle-not-draggable"),
			draggable: f,
			onDragStart: (t) => {
				a(!0), e.hideOtherElements(!0), e.orientation === "column" ? l.colDragStart(t) : l.rowDragStart(t);
			},
			onDragEnd: () => {
				l.dragEnd(), e.hideOtherElements(!1), a(!1);
			},
			style: e.orientation === "column" ? { transform: "rotate(0.25turn)" } : void 0,
			children: e.children || /* @__PURE__ */ K(Kt, {
				size: 24,
				"data-test": "tableHandle"
			})
		}) }), /* @__PURE__ */ K(o, { orientation: e.orientation })]
	}) : null;
}, Ar = (e) => {
	let t = c(), [n, r] = D(), i = u(P), a = w(() => {
		let e = {};
		if (i === void 0) return {};
		let n = Ve(i.block.id, t.prosemirrorState.doc);
		if (!n) return {};
		let r = n.posBeforeNode + 1, a = t.prosemirrorView.domAtPos(r + 1).node;
		if (!(a instanceof Element)) return {};
		if (e.tableReference = { element: a }, i.rowIndex === void 0 || i.colIndex === void 0) return e;
		let o = t.prosemirrorState.doc.resolve(r + 1).posAtIndex(i.rowIndex), s = t.prosemirrorState.doc.resolve(o + 1).posAtIndex(i.colIndex), c = t.prosemirrorView.domAtPos(s + 1).node;
		return c instanceof Element ? (e.cellReference = { element: c }, e.rowReference = {
			element: a,
			getBoundingClientRect: () => {
				let e = a.getBoundingClientRect(), t = c.getBoundingClientRect();
				return new DOMRect(e.x, i.draggingState && i.draggingState.draggedCellOrientation === "row" ? i.draggingState.mousePos - t.height / 2 : t.y, e.width, t.height);
			}
		}, e.columnReference = {
			element: a,
			getBoundingClientRect: () => {
				let e = a.getBoundingClientRect(), t = c.getBoundingClientRect();
				return new DOMRect(i.draggingState && i.draggingState.draggedCellOrientation === "col" ? i.draggingState.mousePos - t.width / 2 : t.x, e.y, t.width, e.height);
			}
		}, e) : {};
	}, [t, i]), o = S((e, n, r) => {
		let i = !1;
		return ge(e, n, () => {
			if (!i) {
				i = !0;
				return;
			}
			t.getExtension(P)?.hideHandlesIfNotFrozen();
		}, {
			ancestorScroll: !0,
			ancestorResize: !1,
			elementResize: !1,
			layoutShift: !1
		});
	}, [t]), s = w(() => i === void 0 ? void 0 : {
		rowTableHandle: {
			useFloatingOptions: {
				open: i.show && i.rowIndex !== void 0 && (!n || n === "rowTableHandle"),
				placement: "left",
				middleware: [F(-10)],
				whileElementsMounted: o
			},
			focusManagerProps: { disabled: !0 },
			elementProps: { style: { zIndex: 10 } }
		},
		columnTableHandle: {
			useFloatingOptions: {
				open: i.show && i.colIndex !== void 0 && (!n || n === "columnTableHandle"),
				placement: "top",
				middleware: [F(-12)],
				whileElementsMounted: o
			},
			focusManagerProps: { disabled: !0 },
			elementProps: { style: { zIndex: 10 } }
		},
		tableCellHandle: {
			useFloatingOptions: {
				open: i.show && i.rowIndex !== void 0 && i.colIndex !== void 0 && (!n || n === "tableCellHandle"),
				placement: "top-end",
				middleware: [F({
					mainAxis: -15,
					crossAxis: -1
				})],
				whileElementsMounted: o
			},
			focusManagerProps: { disabled: !0 },
			elementProps: { style: { zIndex: 10 } }
		},
		extendRowsButton: {
			useFloatingOptions: {
				open: i.show && i.showAddOrRemoveRowsButton && (!n || n === "extendRowsButton"),
				placement: "bottom",
				whileElementsMounted: o,
				middleware: [I({ apply({ rects: e, elements: t }) {
					Object.assign(t.floating.style, { width: `${e.reference.width}px` });
				} })]
			},
			focusManagerProps: { disabled: !0 },
			elementProps: { style: { zIndex: 10 } }
		},
		extendColumnsButton: {
			useFloatingOptions: {
				open: i.show && i.showAddOrRemoveColumnsButton && (!n || n === "extendColumnsButton"),
				placement: "right",
				whileElementsMounted: o,
				middleware: [I({ apply({ rects: e, elements: t }) {
					Object.assign(t.floating.style, { height: `${e.reference.height}px` });
				} })]
			},
			focusManagerProps: { disabled: !0 },
			elementProps: { style: { zIndex: 10 } }
		}
	}, [
		n,
		i,
		o
	]);
	if (!i) return null;
	let l = e.tableHandle || kr, d = e.extendButton || vr, f = e.tableCellHandle || Sr;
	return /* @__PURE__ */ q(G, { children: [
		/* @__PURE__ */ K(p, {
			reference: a?.rowReference,
			portalElement: e.portalElement,
			...s?.rowTableHandle,
			children: i.show && i.rowIndex !== void 0 && (!n || n === "rowTableHandle") && /* @__PURE__ */ K(l, {
				orientation: "row",
				hideOtherElements: (e) => r(e ? "rowTableHandle" : void 0)
			})
		}),
		/* @__PURE__ */ K(p, {
			reference: a?.columnReference,
			portalElement: e.portalElement,
			...s?.columnTableHandle,
			children: i.show && i.colIndex !== void 0 && (!n || n === "columnTableHandle") && /* @__PURE__ */ K(l, {
				orientation: "column",
				hideOtherElements: (e) => r(e ? "columnTableHandle" : void 0)
			})
		}),
		/* @__PURE__ */ K(p, {
			reference: a?.cellReference,
			portalElement: e.portalElement,
			...s?.tableCellHandle,
			children: i.show && i.rowIndex !== void 0 && i.colIndex !== void 0 && (!n || n === "tableCellHandle") && /* @__PURE__ */ K(f, { hideOtherElements: (e) => r(e ? "tableCellHandle" : void 0) })
		}),
		/* @__PURE__ */ K(p, {
			reference: a?.tableReference,
			portalElement: e.portalElement,
			...s?.extendRowsButton,
			children: i.show && i.showAddOrRemoveRowsButton && (!n || n === "extendRowsButton") && /* @__PURE__ */ K(d, {
				orientation: "addOrRemoveRows",
				hideOtherElements: (e) => r(e ? "extendRowsButton" : void 0)
			})
		}),
		/* @__PURE__ */ K(p, {
			reference: a?.tableReference,
			portalElement: e.portalElement,
			...s?.extendColumnsButton,
			children: i.show && i.showAddOrRemoveColumnsButton && (!n || n === "extendColumnsButton") && /* @__PURE__ */ K(d, {
				orientation: "addOrRemoveColumns",
				hideOtherElements: (e) => r(e ? "extendColumnsButton" : void 0)
			})
		})
	] });
};
//#endregion
//#region src/editor/portalElements.ts
function Y(e) {
	if (e !== void 0) {
		if (e === null) return typeof document < "u" ? document.body : void 0;
		if (typeof e == "string") {
			if (typeof document > "u") return;
			let t = document.querySelector(e);
			if (!t) {
				console.warn(`[BlockNote] portalElements selector "${e}" did not match any element`);
				return;
			}
			return t;
		}
		return e;
	}
}
//#endregion
//#region src/editor/BlockNoteDefaultUI.tsx
var jr = x(() => import("./FloatingComposerController-D-j-wzDn.js").then((e) => e.n)), Mr = x(() => import("./FloatingThreadController-BClaFoNJ.js").then((e) => e.n));
function Nr(e) {
	let t = c();
	if (!t) throw Error("BlockNoteDefaultUI must be used within a BlockNoteContext.Provider");
	let n = e.portalElements, r = Y(n?.formattingToolbar), i = Y(n?.linkToolbar), a = Y(n?.slashMenu), o = Y(n?.emojiPicker), s = Y(n?.sideMenu), l = Y(n?.filePanel), u = Y(n?.tableHandles), d = Y(n?.comments);
	return /* @__PURE__ */ q(G, { children: [
		t.getExtension(A) && e.formattingToolbar !== !1 && /* @__PURE__ */ K(Vn, { portalElement: r }),
		t.getExtension(j) && e.linkToolbar !== !1 && /* @__PURE__ */ K(Kn, { portalElement: i }),
		t.getExtension(N) && e.slashMenu !== !1 && /* @__PURE__ */ K(gr, {
			triggerCharacter: "/",
			shouldOpen: (e) => !e.selection.$from.parent.type.isInGroup("tableContent"),
			portalElement: a
		}),
		t.getExtension(N) && e.emojiPicker !== !1 && /* @__PURE__ */ K(cr, {
			triggerCharacter: ":",
			columns: 10,
			minQueryLength: 2,
			portalElement: o
		}),
		t.getExtension(M) && e.sideMenu !== !1 && /* @__PURE__ */ K(tr, { portalElement: s }),
		t.getExtension(k) && e.filePanel !== !1 && /* @__PURE__ */ K(cn, { portalElement: l }),
		t.getExtension(P) && e.tableHandles !== !1 && /* @__PURE__ */ K(Ar, { portalElement: u }),
		t.getExtension(O) && e.comments !== !1 && /* @__PURE__ */ q(re, { children: [/* @__PURE__ */ K(jr, { portalElement: d }), /* @__PURE__ */ K(Mr, { portalElement: d })] })
	] });
}
//#endregion
//#region src/hooks/useEditorChange.ts
function Pr(e, t) {
	let n = i();
	t ||= n?.editor, C(() => {
		if (!t) throw Error("'editor' is required, either from BlockNoteContext or as a function argument");
		return t.onChange(e);
	}, [e, t]);
}
//#endregion
//#region src/hooks/useEditorSelectionChange.ts
function Fr(e, t, n) {
	let r = i();
	t ||= r?.editor, C(() => {
		if (!t) throw Error("'editor' is required, either from BlockNoteContext or as a function argument");
		return t.onSelectionChange(e, n);
	}, [
		e,
		t,
		n
	]);
}
//#endregion
//#region src/hooks/usePrefersColorScheme.ts
var Ir = () => {
	let e = w(() => window.matchMedia?.("(prefers-color-scheme: dark)"), []), t = w(() => window.matchMedia?.("(prefers-color-scheme: light)"), []), n = e?.matches, r = t?.matches, [i, a] = D(n ? "dark" : r ? "light" : "no-preference");
	return C(() => {
		a(n ? "dark" : r ? "light" : "no-preference");
	}, [n, r]), C(() => {
		if (typeof e?.addEventListener == "function") {
			let n = ({ matches: e }) => e && a("dark"), r = ({ matches: e }) => e && a("light");
			return e?.addEventListener("change", n), t?.addEventListener("change", r), () => {
				e?.removeEventListener("change", n), t?.removeEventListener("change", r);
			};
		} else {
			let n = () => a(e.matches ? "dark" : t.matches ? "light" : "no-preference");
			return e?.addEventListener("change", n), t?.addEventListener("change", n), () => {
				e?.removeEventListener("change", n), t?.removeEventListener("change", n);
			};
		}
	}, [e, t]), window.matchMedia, i;
}, Lr = ie(void 0);
function Rr() {
	return oe(Lr);
}
//#endregion
//#region src/editor/EditorContent.tsx
function zr() {
	let e = /* @__PURE__ */ new Set(), t = {};
	return {
		subscribe(t) {
			return e.add(t), () => {
				e.delete(t);
			};
		},
		getSnapshot() {
			return t;
		},
		getServerSnapshot() {
			return t;
		},
		setRenderer(n, r) {
			t = {
				...t,
				[n]: qt(r.reactElement, r.element, n)
			}, e.forEach((e) => e());
		},
		removeRenderer(n) {
			let r = { ...t };
			delete r[n], t = r, e.forEach((e) => e());
		}
	};
}
var Br = ({ contentComponent: e }) => {
	let t = ce(e.subscribe, e.getSnapshot, e.getServerSnapshot);
	return /* @__PURE__ */ K(G, { children: Object.values(t) });
}, Vr = ae((e, t) => {
	let [n, r] = D();
	return se(t, () => (e, t) => {
		Jt(() => {
			r({
				node: e,
				container: t
			});
		}), r(void 0);
	}, []), /* @__PURE__ */ K(G, { children: n && qt(n.node, n.container) });
}), Hr = () => {};
function Ur(e, t) {
	let { editor: n, className: r, theme: o, children: c, editable: l, onSelectionChange: u, onChange: d, formattingToolbar: f, linkToolbar: p, slashMenu: m, emojiPicker: h, sideMenu: g, filePanel: _, tableHandles: v, comments: y, portalElements: b, autoFocus: ee, renderEditor: te = !0, ...ne } = e, re = w(() => Y(b?.default) ?? null, [b?.default]), [ie, ae] = D(), x = i(), oe = Ir(), se = x?.colorSchemePreference || oe, T = o || (se === "dark" ? "dark" : "light"), E = s(), ce = w(() => ({
		formattingToolbar: E ? f : !1,
		linkToolbar: E ? p : !1,
		sideMenu: E ? g : !1,
		slashMenu: E ? m : !1,
		filePanel: E ? _ : !1,
		tableHandles: E ? v : !1,
		emojiPicker: E ? h : !1,
		comments: E ? y : !1,
		portalElements: b
	}), [
		y,
		E,
		h,
		_,
		f,
		p,
		g,
		m,
		v,
		b
	]);
	Pr(d || Hr, n), Fr(u || Hr, n);
	let O = S((e) => {
		n.elementRenderer = e;
	}, [n]);
	C(() => {
		if (!n.portalElement) throw Error("Portal element not found");
		n.portalElement.className = W("bn-root", T, r || ""), n.portalElement.setAttribute("data-color-scheme", T);
	}, [
		n,
		T,
		r
	]);
	let le = w(() => ({
		...x,
		editor: n,
		setContentEditableProps: ae,
		colorSchemePreference: T
	}), [
		x,
		n,
		T
	]), k = w(() => ({
		editorProps: {
			autoFocus: ee,
			contentEditableProps: ie,
			editable: l,
			portalTarget: re
		},
		defaultUIProps: ce
	}), [
		ee,
		ie,
		l,
		ce,
		re
	]);
	return /* @__PURE__ */ K(a.Provider, {
		value: le,
		children: /* @__PURE__ */ q(Lr.Provider, {
			value: k,
			children: [/* @__PURE__ */ K(Vr, { ref: O }), /* @__PURE__ */ K(Wr, {
				className: r,
				renderEditor: te,
				editorColorScheme: T,
				ref: t,
				...ne,
				children: c
			})]
		})
	});
}
var Wr = ne.forwardRef(({ className: e, renderEditor: t, editorColorScheme: n, children: r, ...i }, a) => /* @__PURE__ */ K("div", {
	className: W("bn-root", "bn-container", n, e),
	"data-color-scheme": n,
	...i,
	ref: a,
	children: t ? /* @__PURE__ */ K(Kr, { children: r }) : r
})), Gr = ne.forwardRef(Ur), Kr = (e) => {
	let t = Rr(), n = c(), r = w(() => zr(), []), i = t.editorProps.portalTarget, a = S((e) => {
		n.isEditable = t.editorProps.editable !== !1, n._tiptapEditor.contentComponent = r, e ? n.mount(e, { portalTarget: i }) : n.unmount();
	}, [
		t.editorProps.editable,
		n,
		r,
		i
	]);
	return /* @__PURE__ */ q(G, { children: [
		/* @__PURE__ */ K(Br, { contentComponent: r }),
		/* @__PURE__ */ K(qr, {
			...t.editorProps,
			...e,
			mount: a
		}),
		/* @__PURE__ */ K(Nr, { ...t.defaultUIProps }),
		e.children
	] });
}, qr = (e) => {
	let { autoFocus: t, mount: n, contentEditableProps: r } = e;
	return /* @__PURE__ */ K("div", {
		"aria-autocomplete": "list",
		"aria-haspopup": "listbox",
		"data-bn-autofocus": t,
		ref: n,
		...r
	});
};
//#endregion
//#region src/schema/@util/ReactRenderUtil.ts
function X(e, t) {
	let n, r = document.createElement("div"), i;
	if (t?.elementRenderer) t.elementRenderer(e((e) => n = e || void 0), r);
	else {
		if (!t?.headless) throw Error("elementRenderer not available, expected headless editor");
		i = tn(r), Jt(() => {
			i.render(e((e) => n = e || void 0));
		});
	}
	if (!r.childElementCount) return console.warn("ReactInlineContentSpec: renderHTML() failed"), { dom: document.createElement("span") };
	n?.setAttribute("data-tmp-find", "true");
	let a = r.cloneNode(!0), o = a.firstElementChild, s = a.querySelector("[data-tmp-find]");
	return s?.removeAttribute("data-tmp-find"), i?.unmount(), {
		dom: o,
		contentDOM: s || void 0
	};
}
//#endregion
//#region src/schema/ReactBlockSpec.tsx
function Jr(e) {
	return /* @__PURE__ */ K(Xt, {
		onDragOver: (e) => e.preventDefault(),
		...Object.fromEntries(Object.entries(e.domAttributes || {}).filter(([e]) => e !== "class")),
		className: W("bn-block-content", e.domAttributes?.class || ""),
		"data-content-type": e.blockType,
		...Object.fromEntries(Object.entries(e.blockProps).filter(([t, n]) => n !== e.propSchema[t].default).map(([e, t]) => [ke(e), t])),
		"data-file-block": e.isFileBlock === !0 || void 0,
		children: e.children
	});
}
function Z(e, t, n) {
	return (r = {}) => {
		let i = typeof e == "function" ? e(r) : e, a = typeof t == "function" ? t(r) : t, o = n ? typeof n == "function" ? n(r) : n : void 0;
		return {
			config: i,
			implementation: {
				...a,
				toExternalHTML(e, t, n) {
					let r = a.toExternalHTML || a.render;
					return X((o) => /* @__PURE__ */ K(Jr, {
						blockType: e.type,
						blockProps: e.props,
						propSchema: i.propSchema,
						domAttributes: this.blockContentDOMAttributes,
						isFileBlock: a.meta?.fileBlockAccept !== void 0,
						children: /* @__PURE__ */ K(r, {
							block: e,
							editor: t,
							contentRef: (e) => {
								o(e), e && (e.className = W("bn-inline-content", e.className));
							},
							context: n
						})
					}), t);
				},
				render(e, t) {
					if (this.renderType === "nodeView") return $t((e) => {
						let n = Re(e.getPos, t, e.editor, i.type), r = en().nodeViewContentRef;
						if (!r) throw Error("nodeViewContentRef is not set");
						let o = a.render;
						return /* @__PURE__ */ K(Jr, {
							blockType: n.type,
							blockProps: n.props,
							propSchema: i.propSchema,
							isFileBlock: !!a.meta?.fileBlockAccept,
							domAttributes: this.blockContentDOMAttributes,
							children: /* @__PURE__ */ K(o, {
								block: n,
								editor: t,
								contentRef: (e) => {
									r(e), e && (e.className = W("bn-inline-content", e.className), e.dataset.nodeViewContent = "");
								}
							})
						});
					}, { className: "bn-react-node-view-renderer" })(this.props);
					{
						let n = a.render;
						return X((r) => /* @__PURE__ */ K(Jr, {
							blockType: e.type,
							blockProps: e.props,
							propSchema: i.propSchema,
							domAttributes: this.blockContentDOMAttributes,
							children: /* @__PURE__ */ K(n, {
								block: e,
								editor: t,
								contentRef: (e) => {
									r(e), e && (e.className = W("bn-inline-content", e.className));
								}
							})
						}), t);
					}
				}
			},
			extensions: o
		};
	};
}
//#endregion
//#region src/blocks/File/useResolveUrl.tsx
function Yr(e) {
	let t = c(), [n, r] = D("loading"), [i, a] = D();
	if (C(() => {
		let n = !0;
		return (async () => {
			let i = "";
			r("loading");
			try {
				i = t.resolveFileUrl ? await t.resolveFileUrl(e) : e;
			} catch {
				r("error");
				return;
			}
			n && (r("loaded"), a(i));
		})(), () => {
			n = !1;
		};
	}, [t, e]), n !== "loaded") return { loadingState: n };
	if (!i) throw Error("Finished fetching file but did not get download URL.");
	return {
		loadingState: n,
		downloadUrl: i
	};
}
//#endregion
//#region src/blocks/File/helpers/toExternalHTML/FigureWithCaption.tsx
var Xr = (e) => /* @__PURE__ */ q("figure", { children: [e.children, /* @__PURE__ */ K("figcaption", { children: e.caption })] });
//#endregion
//#region src/hooks/useOnUploadEnd.ts
function Zr(e) {
	let t = c();
	C(() => t.onUploadEnd(e), [e, t]);
}
//#endregion
//#region src/hooks/useOnUploadStart.ts
function Qr(e) {
	let t = c();
	C(() => t.onUploadStart(e), [e, t]);
}
//#endregion
//#region src/hooks/useUploadLoading.ts
function $r(e) {
	let [t, n] = D(!1);
	return Qr((t) => {
		t === e && n(!0);
	}), Zr((t) => {
		t === e && n(!1);
	}), t;
}
//#endregion
//#region src/blocks/File/helpers/render/AddFileButton.tsx
var ei = (e) => {
	let t = c(), n = f(), i = r(k);
	return /* @__PURE__ */ q("div", {
		className: "bn-add-file-button",
		onMouseDown: S((e) => {
			e.preventDefault();
		}, []),
		onClick: S(() => {
			t.isEditable && e.editor.transact(() => i.showMenu(e.block.id));
		}, [
			t.isEditable,
			i,
			e.block.id,
			e.editor
		]),
		children: [/* @__PURE__ */ K("div", {
			className: "bn-add-file-button-icon",
			children: e.buttonIcon || /* @__PURE__ */ K(ft, { size: 24 })
		}), /* @__PURE__ */ K("div", {
			className: "bn-add-file-button-text",
			children: e.block.type in n.file_blocks.add_button_text ? n.file_blocks.add_button_text[e.block.type] : n.file_blocks.add_button_text.file
		})]
	});
}, ti = (e) => /* @__PURE__ */ q("div", {
	className: "bn-file-name-with-icon",
	contentEditable: !1,
	draggable: !1,
	children: [/* @__PURE__ */ K("div", {
		className: "bn-file-icon",
		children: /* @__PURE__ */ K(ft, { size: 24 })
	}), /* @__PURE__ */ K("p", {
		className: "bn-file-name",
		children: e.block.props.name
	})]
}), ni = (e) => {
	let t = $r(e.block.id);
	return /* @__PURE__ */ K(e.block.props.url !== "" && e.block.props.caption && !t ? "figure" : "div", {
		className: "bn-file-block-content-wrapper",
		onMouseEnter: e.onMouseEnter,
		onMouseLeave: e.onMouseLeave,
		style: e.style,
		children: t ? /* @__PURE__ */ K("div", {
			className: "bn-file-loading-preview",
			children: "Loading..."
		}) : e.block.props.url === "" ? /* @__PURE__ */ K(ei, { ...e }) : /* @__PURE__ */ q(G, { children: [e.block.props.showPreview === !1 || !e.children ? /* @__PURE__ */ K(ti, { ...e }) : e.children, e.block.props.caption && /* @__PURE__ */ K("figcaption", {
			className: "bn-file-caption",
			children: e.block.props.caption
		})] })
	});
}, Q = (e) => /* @__PURE__ */ q("div", { children: [e.children, /* @__PURE__ */ K("p", { children: e.caption })] }), ri = (e) => {
	let t = Yr(e.block.props.url);
	return /* @__PURE__ */ K("audio", {
		className: "bn-audio",
		src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
		controls: !0,
		contentEditable: !1,
		draggable: !1
	});
}, ii = (e) => {
	if (!e.block.props.url) return /* @__PURE__ */ K("p", { children: "Add audio" });
	let t = e.block.props.showPreview ? /* @__PURE__ */ K("audio", { src: e.block.props.url }) : /* @__PURE__ */ K("a", {
		href: e.block.props.url,
		children: e.block.props.name || e.block.props.url
	});
	return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ K(Xr, {
		caption: e.block.props.caption,
		children: t
	}) : /* @__PURE__ */ K(Q, {
		caption: e.block.props.caption,
		children: t
	}) : t;
}, ai = (e) => /* @__PURE__ */ K(ni, {
	...e,
	buttonIcon: /* @__PURE__ */ K(Ut, { size: 24 }),
	children: /* @__PURE__ */ K(ri, { ...e })
}), oi = Z(Ae, (e) => ({
	meta: { fileBlockAccept: ["audio/*"] },
	render: ai,
	parse: Oe(e),
	toExternalHTML: ii,
	runsBefore: ["file"]
})), si = Z(je, {
	render: (e) => /* @__PURE__ */ K(ni, { ...e }),
	parse: Ie(),
	toExternalHTML: (e) => {
		if (!e.block.props.url) return /* @__PURE__ */ K("p", { children: "Add file" });
		let t = /* @__PURE__ */ K("a", {
			href: e.block.props.url,
			children: e.block.props.name || e.block.props.url
		});
		return e.block.props.caption ? /* @__PURE__ */ K(Q, {
			caption: e.block.props.caption,
			children: t
		}) : t;
	}
}), ci = (e) => {
	let [t, n] = D(void 0), [r, i] = D(e.block.props.previewWidth), [a, o] = D(!1), s = E(null);
	C(() => {
		let a = (n) => {
			let r, a = "touches" in n ? n.touches[0].clientX : n.clientX;
			r = e.block.props.textAlignment === "center" ? t.handleUsed === "left" ? t.initialWidth + (t.initialClientX - a) * 2 : t.initialWidth + (a - t.initialClientX) * 2 : t.handleUsed === "left" ? t.initialWidth + t.initialClientX - a : t.initialWidth + a - t.initialClientX, i(Math.min(Math.max(r, 64), e.editor.domElement?.firstElementChild?.clientWidth || Number.MAX_VALUE));
		}, o = () => {
			n(void 0), e.editor.updateBlock(e.block, { props: { previewWidth: r } });
		};
		return t && (window.addEventListener("mousemove", a), window.addEventListener("touchmove", a), window.addEventListener("mouseup", o), window.addEventListener("touchend", o)), () => {
			window.removeEventListener("mousemove", a), window.removeEventListener("touchmove", a), window.removeEventListener("mouseup", o), window.removeEventListener("touchend", o);
		};
	}, [
		e,
		t,
		r
	]);
	let c = S(() => {
		e.editor.isEditable && o(!0);
	}, [e.editor.isEditable]), l = S(() => {
		o(!1);
	}, []), u = S((e) => {
		e.preventDefault();
		let t = "touches" in e ? e.touches[0].clientX : e.clientX;
		n({
			handleUsed: "left",
			initialWidth: s.current.clientWidth,
			initialClientX: t
		});
	}, []), d = S((e) => {
		e.preventDefault();
		let t = "touches" in e ? e.touches[0].clientX : e.clientX;
		n({
			handleUsed: "right",
			initialWidth: s.current.clientWidth,
			initialClientX: t
		});
	}, []), f = $r(e.block.id);
	return /* @__PURE__ */ K(ni, {
		...e,
		onMouseEnter: c,
		onMouseLeave: l,
		style: e.block.props.url && !f && e.block.props.showPreview ? { width: r ? `${r}px` : "fit-content" } : void 0,
		children: /* @__PURE__ */ q("div", {
			className: "bn-visual-media-wrapper",
			style: { position: "relative" },
			ref: s,
			children: [
				e.children,
				/* @__PURE__ */ K("div", {
					className: "bn-resize-handle",
					style: {
						left: "4px",
						display: a || t ? "initial" : "none"
					},
					onMouseDown: u,
					onTouchStart: u
				}),
				/* @__PURE__ */ K("div", {
					className: "bn-resize-handle",
					style: {
						right: "4px",
						display: a || t ? "initial" : "none"
					},
					onMouseDown: d,
					onTouchStart: d
				}),
				t && /* @__PURE__ */ K("div", { style: {
					position: "absolute",
					height: "100%",
					width: "100%"
				} })
			]
		})
	});
}, li = (e) => {
	let t = Yr(e.block.props.url), n = e.block.props.name || "";
	return /* @__PURE__ */ K("img", {
		className: "bn-visual-media",
		src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
		alt: n,
		width: e.block.props.previewWidth,
		contentEditable: !1,
		draggable: !1
	});
}, ui = (e) => {
	if (!e.block.props.url) return /* @__PURE__ */ K("p", { children: "Add image" });
	let t = e.block.props.name || "", n = e.block.props.showPreview ? /* @__PURE__ */ K("img", {
		src: e.block.props.url,
		alt: t,
		width: e.block.props.previewWidth
	}) : /* @__PURE__ */ K("a", {
		href: e.block.props.url,
		children: e.block.props.name || e.block.props.url
	});
	return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ K(Xr, {
		caption: e.block.props.caption,
		children: n
	}) : /* @__PURE__ */ K(Q, {
		caption: e.block.props.caption,
		children: n
	}) : n;
}, di = (e) => /* @__PURE__ */ K(ci, {
	...e,
	buttonIcon: /* @__PURE__ */ K(xt, { size: 24 }),
	children: /* @__PURE__ */ K(li, { ...e })
}), fi = Z(Me, (e) => ({
	meta: { fileBlockAccept: ["image/*"] },
	render: di,
	parse: Ge(e),
	toExternalHTML: ui,
	runsBefore: ["file"]
})), pi = { page_break: nn };
function mi(e) {
	return He(e).map((e) => {
		let t = pi[e.key];
		return {
			...e,
			icon: /* @__PURE__ */ K(t, { size: 18 })
		};
	});
}
//#endregion
//#region src/blocks/Video/block.tsx
var hi = (e) => {
	let t = Yr(e.block.props.url);
	return /* @__PURE__ */ K("video", {
		className: "bn-visual-media",
		src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
		controls: !0,
		width: e.block.props.previewWidth || void 0,
		contentEditable: !1,
		draggable: !1
	});
}, gi = (e) => {
	if (!e.block.props.url) return /* @__PURE__ */ K("p", { children: "Add video" });
	let t = e.block.props.showPreview ? /* @__PURE__ */ K("video", {
		src: e.block.props.url,
		width: e.block.props.previewWidth || void 0
	}) : /* @__PURE__ */ K("a", {
		href: e.block.props.url,
		children: e.block.props.name || e.block.props.url
	});
	return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ K(Xr, {
		caption: e.block.props.caption,
		children: t
	}) : /* @__PURE__ */ K(Q, {
		caption: e.block.props.caption,
		children: t
	}) : t;
}, _i = (e) => /* @__PURE__ */ K(ci, {
	...e,
	buttonIcon: /* @__PURE__ */ K(Ht, { size: 24 }),
	children: /* @__PURE__ */ K(hi, { ...e })
}), vi = Z(Fe, (e) => ({
	meta: { fileBlockAccept: ["video/*"] },
	render: _i,
	parse: Ze(e),
	toExternalHTML: gi,
	runsBefore: ["file"]
})), yi = (e, t) => {
	if (t.type === "toggled") return !e;
	if (t.type === "childAdded") return !0;
	if (t.type === "lastChildRemoved") return !1;
	throw new we(t);
}, bi = (e) => {
	let { block: t, editor: n, children: r, toggledState: i } = e, [a, o] = T(yi, (i || z).get(t)), s = (e) => {
		(i || z).set(n.getBlock(e), !a), o({ type: "toggled" });
	}, c = (e) => {
		(i || z).set(e, !0), o({ type: "childAdded" });
	}, u = (e) => {
		(i || z).set(e, !1), o({ type: "lastChildRemoved" });
	}, d = l({
		editor: n,
		selector: ({ editor: e }) => {
			if (!L(t, e, t.type, { isToggleable: "boolean" }) && !t.props.isToggleable) return 0;
			let n = e.getBlock(t), r = n.children.length || 0;
			return r > d ? a || c(n) : r === 0 && r < d && a && u(n), r;
		}
	});
	return "isToggleable" in t.props && !t.props.isToggleable ? r : /* @__PURE__ */ q("div", { children: [/* @__PURE__ */ q("div", {
		className: "bn-toggle-wrapper",
		"data-show-children": a,
		children: [/* @__PURE__ */ K("button", {
			className: "bn-toggle-button",
			type: "button",
			onMouseDown: (e) => e.preventDefault(),
			onClick: () => s(n.getBlock(t)),
			children: /* @__PURE__ */ K("svg", {
				xmlns: "http://www.w3.org/2000/svg",
				height: "1em",
				viewBox: "0 -960 960 960",
				width: "1em",
				fill: "currentcolor",
				children: /* @__PURE__ */ K("path", { d: "M472-480 332-620q-18-18-18-44t18-44q18-18 44-18t44 18l183 183q9 9 14 21t5 24q0 12-5 24t-14 21L420-252q-18 18-44 18t-44-18q-18-18-18-44t18-44l140-140Z" })
			})
		}), r]
	}), n.isEditable && a && d === 0 && /* @__PURE__ */ K("button", {
		className: "bn-toggle-add-block-button",
		type: "button",
		onClick: () => {
			let e = n.updateBlock(t, { children: [{}] });
			n.setTextCursorPosition(e.children[0].id, "end"), n.focus();
		},
		children: n.dictionary.toggle_blocks.add_block_button
	})] });
}, xi = (e) => {
	let t = E(null), n = u(A, { editor: c() });
	return C(() => {
		let e = t.current;
		if (!e) return;
		let n = (t) => {
			e.style.setProperty("--bn-mobile-keyboard-offset", t > 0 ? `${t}px` : "0px");
		}, r, i = () => {
			let t = window.getSelection();
			if (!t || t.rangeCount === 0) return;
			let n = t.getRangeAt(0).getBoundingClientRect(), r = window.visualViewport;
			if (!r) return;
			let i = e.getBoundingClientRect().height || 44, a = r.offsetTop + r.height - i;
			n.bottom > a ? window.scrollBy({
				top: n.bottom - a + 16,
				behavior: "smooth"
			}) : n.top < r.offsetTop && window.scrollBy({
				top: n.top - r.offsetTop - 16,
				behavior: "smooth"
			});
		}, a = navigator.virtualKeyboard;
		if (a) {
			a.overlaysContent = !0;
			let e = () => {
				n(a.boundingRect.height), clearTimeout(r), r = setTimeout(i, 100);
			};
			a.addEventListener("geometrychange", e);
			let t = () => i();
			return document.addEventListener("selectionchange", t), () => {
				a.removeEventListener("geometrychange", e), document.removeEventListener("selectionchange", t), clearTimeout(r);
			};
		}
		let o = window.visualViewport;
		if (!o) return;
		let s = 0, c = () => {
			let e = document.documentElement.clientHeight - o.height - o.offsetTop;
			e > 50 && (s = e), n(e), clearTimeout(r), r = setTimeout(i, 100);
		}, l = (e) => {
			let t = e.target;
			(t.isContentEditable || t.tagName === "INPUT" || t.tagName === "TEXTAREA") && s > 0 && n(s);
		}, u = () => {
			n(0);
		}, d = () => i();
		return o.addEventListener("resize", c), o.addEventListener("scroll", c), document.addEventListener("focusin", l), document.addEventListener("focusout", u), document.addEventListener("selectionchange", d), () => {
			o.removeEventListener("resize", c), o.removeEventListener("scroll", c), document.removeEventListener("focusin", l), document.removeEventListener("focusout", u), document.removeEventListener("selectionchange", d), clearTimeout(r);
		};
	}, []), !n && t.current ? /* @__PURE__ */ K("div", {
		ref: t,
		className: "bn-mobile-formatting-toolbar",
		dangerouslySetInnerHTML: { __html: t.current.innerHTML }
	}) : /* @__PURE__ */ K("div", {
		ref: t,
		className: "bn-mobile-formatting-toolbar",
		children: /* @__PURE__ */ K(e.formattingToolbar || zn, {})
	});
};
//#endregion
//#region src/components/TableHandles/hooks/useExtendButtonsPositioning.ts
function Si(e, t, n) {
	let { refs: r, update: i, context: a, floatingStyles: o } = be({
		open: t,
		placement: e === "addOrRemoveColumns" ? "right" : "bottom",
		middleware: [I({ apply({ rects: t, elements: n }) {
			Object.assign(n.floating.style, e === "addOrRemoveColumns" ? { height: `${t.reference.height}px` } : { width: `${t.reference.width}px` });
		} })]
	}), { isMounted: s, styles: c } = xe(a);
	return C(() => {
		i();
	}, [n, i]), C(() => {
		n !== null && r.setReference({ getBoundingClientRect: () => n });
	}, [
		e,
		n,
		r
	]), w(() => ({
		isMounted: s,
		ref: r.setFloating,
		style: {
			display: "flex",
			...c,
			...o
		}
	}), [
		o,
		s,
		r.setFloating,
		c
	]);
}
function Ci(e, t, n) {
	let r = Si("addOrRemoveRows", t, n), i = Si("addOrRemoveColumns", e, n);
	return w(() => ({
		addOrRemoveRowsButton: r,
		addOrRemoveColumnsButton: i
	}), [i, r]);
}
//#endregion
//#region src/components/TableHandles/hooks/useTableHandlesPositioning.ts
function wi(e, t, n) {
	return n && n.draggedCellOrientation === "row" ? new DOMRect(t.x, n.mousePos, t.width, 0) : new DOMRect(t.x, e.y, t.width, e.height);
}
function Ti(e, t, n) {
	return n && n.draggedCellOrientation === "col" ? new DOMRect(n.mousePos, t.y, 0, t.height) : new DOMRect(e.x, t.y, e.width, t.height);
}
function Ei(e) {
	return new DOMRect(e.x, e.y, e.width, 0);
}
function Di(e, t, n, r, i) {
	let { refs: a, update: o, context: s, floatingStyles: c } = be({
		open: t,
		placement: e === "row" ? "left" : e === "col" ? "top" : "bottom-end",
		middleware: [F(e === "row" ? -10 : e === "col" ? -12 : {
			mainAxis: 1,
			crossAxis: -1
		})]
	}), { isMounted: l, styles: u } = xe(s);
	return C(() => {
		o();
	}, [
		n,
		r,
		o
	]), C(() => {
		n === null || r === null || i && e === "cell" || a.setReference({ getBoundingClientRect: () => (e === "row" ? wi : e === "col" ? Ti : Ei)(n, r, i) });
	}, [
		i,
		e,
		n,
		r,
		a
	]), w(() => ({
		isMounted: l,
		ref: a.setFloating,
		style: {
			display: "flex",
			...u,
			...c
		}
	}), [
		c,
		l,
		a.setFloating,
		u
	]);
}
function Oi(e, t, n, r) {
	let i = Di("row", e, t, n, r), a = Di("col", e, t, n, r), o = Di("cell", e, t, n, r);
	return w(() => ({
		rowHandle: i,
		colHandle: a,
		cellHandle: o
	}), [
		a,
		i,
		o
	]);
}
//#endregion
//#region src/components/Comments/ThreadsSidebar.tsx
var ki = ne.memo(({ thread: e, selectedThreadId: t, maxCommentsBeforeCollapse: n, referenceText: i, orphaned: a }) => {
	let o = r(O), s = S((t) => {
		t.target.closest(".bn-action-toolbar") || o.selectThread(e.id);
	}, [o, e.id]), c = S((e) => {
		if (!e.relatedTarget || e.relatedTarget.closest(".bn-action-toolbar")) return;
		let t = e.target instanceof Node ? e.target : null, n = e.relatedTarget instanceof Node ? e.relatedTarget.closest(".bn-thread") : null;
		(!t || !n || !n.contains(t)) && o.selectThread(void 0);
	}, [o]);
	return /* @__PURE__ */ K(g, {
		thread: e,
		selected: e.id === t,
		orphaned: a,
		referenceText: i,
		maxCommentsBeforeCollapse: n,
		onFocus: s,
		onBlur: c,
		tabIndex: 0
	});
});
function Ai(e, t, n) {
	if (t === "recent-activity") return e.sort((e, t) => t.comments[t.comments.length - 1].createdAt.getTime() - e.comments[e.comments.length - 1].createdAt.getTime());
	if (t === "oldest") return e.sort((e, t) => e.createdAt.getTime() - t.createdAt.getTime());
	if (t === "position") return e.sort((e, t) => (n?.get(e.id)?.from || Number.MAX_VALUE) - (n?.get(t.id)?.from || Number.MAX_VALUE));
	throw new we(t);
}
function ji(e, t) {
	return e.transact((n) => {
		if (!t) return e.dictionary.comments.deleted_reference_text;
		if (n.doc.nodeSize < t.to) return "";
		let r = n.doc.textBetween(t.from, t.to);
		return r.length > 15 ? `${r.slice(0, 15)}…` : r;
	});
}
function Mi(e) {
	let t = c(), { selectedThreadId: n, threadPositions: r } = u(O), i = v();
	return /* @__PURE__ */ K("div", {
		className: "bn-threads-sidebar",
		children: w(() => {
			let n = Ai(Array.from(i.values()), e.sort || "position", r), a = [];
			for (let i of n) {
				let n = r.get(i.id), o = n === void 0;
				i.resolved ? (e.filter === "resolved" || e.filter === "all") && a.push({
					thread: i,
					referenceText: ji(t, n),
					orphaned: o
				}) : (e.filter === "open" || e.filter === "all") && a.push({
					thread: i,
					referenceText: ji(t, n),
					orphaned: o
				});
			}
			return a;
		}, [
			i,
			e.sort,
			e.filter,
			r,
			t
		]).map((r) => /* @__PURE__ */ K(ki, {
			thread: r.thread,
			selectedThreadId: n,
			editor: t,
			referenceText: r.referenceText,
			orphaned: r.orphaned,
			maxCommentsBeforeCollapse: e.maxCommentsBeforeCollapse
		}, r.thread.id))
	});
}
//#endregion
//#region src/hooks/useActiveStyles.ts
function Ni(e) {
	let t = i();
	if (e ||= t?.editor, !e) throw Error("'editor' is required, either from BlockNoteContext or as a function argument");
	return l({
		editor: e,
		selector: ({ editor: e }) => e.getActiveStyles()
	});
}
//#endregion
//#region src/hooks/useEditorSelectionBoundingBox.ts
function Pi(e, t) {
	return l({
		editor: t,
		selector: ({ editor: t }) => e ? t.getSelectionBoundingBox() : void 0
	});
}
//#endregion
//#region src/hooks/useFocusWithin.ts
function Fi(e) {
	return e.currentTarget instanceof HTMLElement && e.relatedTarget instanceof HTMLElement ? e.currentTarget.contains(e.relatedTarget) : !1;
}
function Ii({ onBlur: e, onFocus: t } = {}) {
	let n = E(null), [r, i] = D(!1), a = E(!1), o = (e) => {
		i(e), a.current = e;
	}, s = (e) => {
		a.current || (o(!0), t?.(e));
	}, c = (t) => {
		a.current && !Fi(t) && (o(!1), e?.(t));
	};
	return C(() => {
		let e = n.current;
		if (e) return e.addEventListener("focusin", s), e.addEventListener("focusout", c), () => {
			e?.removeEventListener("focusin", s), e?.removeEventListener("focusout", c);
		};
	}, [s, c]), {
		ref: n,
		focused: r
	};
}
//#endregion
//#region src/hooks/useSelectedBlocks.ts
function Li(e) {
	return l({
		editor: e,
		selector: ({ editor: e }) => e.getSelection()?.blocks || [e.getTextCursorPosition().block]
	});
}
//#endregion
//#region src/schema/ReactInlineContentSpec.tsx
function $(e) {
	return /* @__PURE__ */ K(Xt, {
		as: "span",
		className: "bn-inline-content-section",
		"data-inline-content-type": e.inlineContentType,
		...Object.fromEntries(Object.entries(e.inlineContentProps).filter(([t, n]) => n !== e.propSchema[t].default).map(([e, t]) => [ke(e), t])),
		children: e.children
	});
}
function Ri(e, t) {
	let n = Qe.create({
		name: e.type,
		inline: !0,
		group: "inline",
		selectable: e.content === "styled",
		atom: e.content === "none",
		draggable: t.meta?.draggable,
		content: e.content === "styled" ? "inline*" : "",
		addAttributes() {
			return Ye(e.propSchema);
		},
		addKeyboardShortcuts() {
			return Ee(e);
		},
		parseHTML() {
			return Be(e, t.parse);
		},
		renderHTML({ node: n }) {
			let r = this.options.editor, i = Je(n, r.schema.inlineContentSchema, r.schema.styleSchema), a = t.toExternalHTML || t.render;
			return Te(X((e) => /* @__PURE__ */ K(a, {
				contentRef: (t) => {
					e(t), t && (t.dataset.editable = "");
				},
				inlineContent: i,
				updateInlineContent: () => {},
				editor: r
			}), r), e.type, n.attrs, e.propSchema);
		},
		addNodeView() {
			let n = this.options.editor;
			return (r) => $t((r) => {
				let i = en().nodeViewContentRef;
				if (!i) throw Error("nodeViewContentRef is not set");
				let a = t.render;
				return /* @__PURE__ */ K($, {
					inlineContentProps: r.node.attrs,
					inlineContentType: e.type,
					propSchema: e.propSchema,
					children: /* @__PURE__ */ K(a, {
						contentRef: (e) => {
							i(e), e && (e.dataset.editable = "");
						},
						editor: n,
						inlineContent: Je(r.node, n.schema.inlineContentSchema, n.schema.styleSchema),
						updateInlineContent: (e) => {
							let t = Ke([e], n.pmSchema), i = r.getPos();
							i !== void 0 && n.transact((e) => e.replaceWith(i, i + r.node.nodeSize, t));
						}
					})
				});
			}, {
				className: "bn-ic-react-node-view-renderer",
				as: "span"
			})(r);
		}
	});
	return Ne(e, {
		...t,
		node: n,
		render(n, r, i) {
			let a = t.render;
			return X((t) => /* @__PURE__ */ K($, {
				inlineContentProps: n.props,
				inlineContentType: e.type,
				propSchema: e.propSchema,
				children: /* @__PURE__ */ K(a, {
					contentRef: (e) => {
						t(e), e && (e.dataset.editable = "");
					},
					editor: i,
					inlineContent: n,
					updateInlineContent: r
				})
			}), i);
		},
		toExternalHTML(n, r) {
			let i = t.toExternalHTML || t.render;
			return X((t) => /* @__PURE__ */ K($, {
				inlineContentProps: n.props,
				inlineContentType: e.type,
				propSchema: e.propSchema,
				children: /* @__PURE__ */ K(i, {
					contentRef: (e) => {
						t(e), e && (e.dataset.editable = "");
					},
					editor: r,
					inlineContent: n,
					updateInlineContent: () => {}
				})
			}), r);
		}
	});
}
//#endregion
//#region src/schema/ReactStyleSpec.tsx
function zi(e, t) {
	let n = Yt.create({
		name: e.type,
		addAttributes() {
			return Xe(e.propSchema);
		},
		parseHTML() {
			return We(e);
		},
		renderHTML({ mark: n }) {
			let r = t.render;
			return De(X((t) => /* @__PURE__ */ K(r, {
				editor: this.options.editor,
				value: e.propSchema === "boolean" ? void 0 : n.attrs.stringValue,
				contentRef: (e) => {
					t(e), e && (e.dataset.editable = "");
				}
			}), this.options.editor), e.type, n.attrs.stringValue, e.propSchema);
		},
		addMarkView() {
			let n = this.options.editor;
			return (r) => {
				let i = Qt((r) => {
					let i = oe(Zt).markViewContentRef;
					if (!i) throw Error("markViewContentRef is not set");
					let a = t.render;
					return /* @__PURE__ */ K(a, {
						editor: n,
						contentRef: (e) => {
							i(e), e && (e.dataset.markViewContent = "");
						},
						value: e.propSchema === "boolean" ? void 0 : r.mark.attrs.stringValue
					});
				})(r);
				return i.didMountContentDomElement = !0, i;
			};
		}
	});
	return Pe(e, {
		...t,
		mark: n,
		render(n, r) {
			let i = t.render;
			return De(X((e) => /* @__PURE__ */ K(i, {
				editor: r,
				value: n,
				contentRef: (t) => {
					e(t), t && (t.dataset.editable = "");
				}
			}), r), e.type, n, e.propSchema);
		},
		toExternalHTML(n, r) {
			let i = t.render;
			return De(X((e) => /* @__PURE__ */ K(i, {
				editor: r,
				value: n,
				contentRef: (t) => {
					e(t), t && (t.dataset.editable = "");
				}
			}), r), e.type, n, e.propSchema);
		}
	});
}
//#endregion
//#region src/util/elementOverflow.ts
function Bi(e, t) {
	let n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), i = n.top < r.top, a = n.bottom > r.bottom;
	return i && a ? "both" : i ? "top" : a ? "bottom" : "none";
}
//#endregion
//#region src/util/mergeRefs.ts
function Vi(e) {
	return (t) => {
		e.forEach((e) => {
			typeof e == "function" ? e(t) : e != null && (e.current = t);
		});
	};
}
//#endregion
export { qn as AddBlockButton, Cr as AddButton, kn as AddCommentButton, On as AddCommentButtonInner, ei as AddFileButton, An as AddTiptapCommentButton, ai as AudioBlock, ri as AudioPreview, ii as AudioToExternalHTML, J as BasicTextStyleButton, Jn as BlockColorsItem, Jr as BlockContentWrapper, a as BlockNoteContext, Nr as BlockNoteDefaultUI, Kr as BlockNoteViewEditor, Gr as BlockNoteViewRaw, rn as BlockPopover, Dn as BlockTypeSelect, yr as ColorPickerButton, hn as ColorStyleButton, _ as Comment, m as Comments, t as ComponentsContext, yn as CreateLinkButton, wr as DeleteButton, Hn as DeleteLinkButton, $n as DragHandleButton, Qn as DragHandleMenu, Un as EditLinkButton, _n as EditLinkMenuItems, an as EmbedTab, xi as ExperimentalMobileFormattingToolbarController, vr as ExtendButton, Xr as FigureWithCaption, ni as FileBlockWrapper, bn as FileCaptionButton, xn as FileDeleteButton, Mn as FileDownloadButton, ti as FileNameWithIcon, sn as FilePanel, cn as FilePanelController, Nn as FilePreviewButton, Sn as FileRenameButton, Cn as FileReplaceButton, ee as FloatingComposer, te as FloatingComposerController, b as FloatingThreadController, zn as FormattingToolbar, Vn as FormattingToolbarController, p as GenericPopover, cr as GridSuggestionMenuController, sr as GridSuggestionMenuWrapper, di as ImageBlock, li as ImagePreview, ui as ImageToExternalHTML, $ as InlineContentWrapper, Gn as LinkToolbar, Kn as LinkToolbarController, Q as LinkWithCaption, wn as NestBlockButton, Wn as OpenLinkButton, o as PositionPopover, oi as ReactAudioBlock, si as ReactFileBlock, fi as ReactImageBlock, vi as ReactVideoBlock, Yn as RemoveBlockItem, ci as ResizableFileBlockWrapper, er as SideMenu, tr as SideMenuController, br as SplitButton, gr as SuggestionMenuController, pr as SuggestionMenuWrapper, Sr as TableCellButton, xr as TableCellMenu, Fn as TableCellMergeButton, Zn as TableColumnHeaderItem, kr as TableHandle, Or as TableHandleMenu, Ar as TableHandlesController, Xn as TableRowHeaderItem, Ln as TextAlignButton, g as Thread, Mi as ThreadsSidebar, bi as ToggleWrapper, Tn as UnnestBlockButton, on as UploadTab, _i as VideoBlock, hi as VideoPreview, gi as VideoToExternalHTML, En as blockTypeSelectItems, Z as createReactBlockSpec, Ri as createReactInlineContentSpec, zi as createReactStyleSpec, Bi as elementOverflow, nr as getDefaultReactEmojiPickerItems, hr as getDefaultReactSlashMenuItems, Rn as getFormattingToolbarItems, n as getMountedBoundingClientRectCache, mi as getPageBreakReactSlashMenuItems, ji as getReferenceText, Vi as mergeRefs, Ni as useActiveStyles, i as useBlockNoteContext, c as useBlockNoteEditor, ir as useCloseSuggestionMenuNoItems, s as useComponentsContext, d as useCreateBlockNote, f as useDictionary, Pr as useEditorChange, e as useEditorDOMElement, Pi as useEditorSelectionBoundingBox, Fr as useEditorSelectionChange, l as useEditorState, Ci as useExtendButtonsPositioning, r as useExtension, u as useExtensionState, Ii as useFocusWithin, or as useGridSuggestionMenuKeyboardNavigation, ar as useLoadSuggestionMenuItems, Zr as useOnUploadEnd, Qr as useOnUploadStart, Ir as usePrefersColorScheme, Yr as useResolveUrl, Li as useSelectedBlocks, ur as useSuggestionMenuKeyboardHandler, fr as useSuggestionMenuKeyboardNavigation, Oi as useTableHandlesPositioning, v as useThreads, $r as useUploadLoading, y as useUser, h as useUsers };

//# sourceMappingURL=blocknote-react.js.map